(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefb72"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefb72"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1ig8x", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6IF0i = parcelRequire("6IF0i");
'use strict';
function $0f13fd461faec947$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0f13fd461faec947$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0f13fd461faec947$var$_typeof(o);
}
function $0f13fd461faec947$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0f13fd461faec947$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0f13fd461faec947$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0f13fd461faec947$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0f13fd461faec947$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0f13fd461faec947$var$_toPropertyKey(arg) {
    var key = $0f13fd461faec947$var$_toPrimitive(arg, "string");
    return $0f13fd461faec947$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0f13fd461faec947$var$_toPrimitive(input, hint) {
    if ($0f13fd461faec947$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0f13fd461faec947$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0f13fd461faec947$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $b5toe = parcelRequire("b5toe");
var $0f13fd461faec947$var$_require$codes = $b5toe.codes, $0f13fd461faec947$var$ERR_AMBIGUOUS_ARGUMENT = $0f13fd461faec947$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $0f13fd461faec947$var$ERR_INVALID_ARG_TYPE = $0f13fd461faec947$var$_require$codes.ERR_INVALID_ARG_TYPE, $0f13fd461faec947$var$ERR_INVALID_ARG_VALUE = $0f13fd461faec947$var$_require$codes.ERR_INVALID_ARG_VALUE, $0f13fd461faec947$var$ERR_INVALID_RETURN_VALUE = $0f13fd461faec947$var$_require$codes.ERR_INVALID_RETURN_VALUE, $0f13fd461faec947$var$ERR_MISSING_ARGS = $0f13fd461faec947$var$_require$codes.ERR_MISSING_ARGS;

var $jMexq = parcelRequire("jMexq");

var $1TaSd = parcelRequire("1TaSd");
var $0f13fd461faec947$var$inspect = $1TaSd.inspect;

var $1TaSd = parcelRequire("1TaSd");
var $0f13fd461faec947$require$_require$types = $1TaSd.types;
var $0f13fd461faec947$var$isPromise = $0f13fd461faec947$require$_require$types.isPromise, $0f13fd461faec947$var$isRegExp = $0f13fd461faec947$require$_require$types.isRegExp;

var $0f13fd461faec947$var$objectAssign = (parcelRequire("75Lx4"))();

var $0f13fd461faec947$var$objectIs = (parcelRequire("bMTt7"))();

var $0f13fd461faec947$var$RegExpPrototypeTest = (parcelRequire("bGpNB"))('RegExp.prototype.test');
var $0f13fd461faec947$var$errorCache = new Map();
var $0f13fd461faec947$var$isDeepEqual;
var $0f13fd461faec947$var$isDeepStrictEqual;
var $0f13fd461faec947$var$parseExpressionAt;
var $0f13fd461faec947$var$findNodeAround;
var $0f13fd461faec947$var$decoder;

function $0f13fd461faec947$var$lazyLoadComparison() {
    var comparison = (parcelRequire("1Pkcj"));
    $0f13fd461faec947$var$isDeepEqual = comparison.isDeepEqual;
    $0f13fd461faec947$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $0f13fd461faec947$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $0f13fd461faec947$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $0f13fd461faec947$var$escapeFn = function escapeFn(str) {
    return $0f13fd461faec947$var$meta[str.charCodeAt(0)];
};
var $0f13fd461faec947$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $0f13fd461faec947$var$assert = module.exports = $0f13fd461faec947$var$ok;
var $0f13fd461faec947$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $0f13fd461faec947$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $jMexq(obj);
}
function $0f13fd461faec947$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($0f13fd461faec947$var$warned === false) {
            $0f13fd461faec947$var$warned = true;
            var warn = $6IF0i.emitWarning ? $6IF0i.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $0f13fd461faec947$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $jMexq(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$0f13fd461faec947$var$assert.fail = $0f13fd461faec947$var$fail;
// The AssertionError is defined in internal/error.
$0f13fd461faec947$var$assert.AssertionError = $jMexq;
function $0f13fd461faec947$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $jMexq({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $0f13fd461faec947$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $0f13fd461faec947$var$innerOk.apply(void 0, [
        $0f13fd461faec947$var$ok,
        args.length
    ].concat(args));
}
$0f13fd461faec947$var$assert.ok = $0f13fd461faec947$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $0f13fd461faec947$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $0f13fd461faec947$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $0f13fd461faec947$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$0f13fd461faec947$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $0f13fd461faec947$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $0f13fd461faec947$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$0f13fd461faec947$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $0f13fd461faec947$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($0f13fd461faec947$var$isDeepEqual === undefined) $0f13fd461faec947$var$lazyLoadComparison();
    if (!$0f13fd461faec947$var$isDeepEqual(actual, expected)) $0f13fd461faec947$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$0f13fd461faec947$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $0f13fd461faec947$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($0f13fd461faec947$var$isDeepEqual === undefined) $0f13fd461faec947$var$lazyLoadComparison();
    if ($0f13fd461faec947$var$isDeepEqual(actual, expected)) $0f13fd461faec947$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $0f13fd461faec947$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $0f13fd461faec947$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($0f13fd461faec947$var$isDeepEqual === undefined) $0f13fd461faec947$var$lazyLoadComparison();
    if (!$0f13fd461faec947$var$isDeepStrictEqual(actual, expected)) $0f13fd461faec947$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$0f13fd461faec947$var$assert.notDeepStrictEqual = $0f13fd461faec947$var$notDeepStrictEqual;
function $0f13fd461faec947$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $0f13fd461faec947$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($0f13fd461faec947$var$isDeepEqual === undefined) $0f13fd461faec947$var$lazyLoadComparison();
    if ($0f13fd461faec947$var$isDeepStrictEqual(actual, expected)) $0f13fd461faec947$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $0f13fd461faec947$var$notDeepStrictEqual
    });
}
$0f13fd461faec947$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $0f13fd461faec947$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$0f13fd461faec947$var$objectIs(actual, expected)) $0f13fd461faec947$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$0f13fd461faec947$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $0f13fd461faec947$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($0f13fd461faec947$var$objectIs(actual, expected)) $0f13fd461faec947$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $0f13fd461faec947$var$Comparison = /*#__PURE__*/ $0f13fd461faec947$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $0f13fd461faec947$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $0f13fd461faec947$var$isRegExp(obj[key]) && $0f13fd461faec947$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $0f13fd461faec947$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$0f13fd461faec947$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $0f13fd461faec947$var$Comparison(actual, keys);
            var b = new $0f13fd461faec947$var$Comparison(expected, keys, actual);
            var err = new $jMexq({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $0f13fd461faec947$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $0f13fd461faec947$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($0f13fd461faec947$var$isRegExp(expected)) return $0f13fd461faec947$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $0f13fd461faec947$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($0f13fd461faec947$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $jMexq({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $0f13fd461faec947$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($0f13fd461faec947$var$isDeepEqual === undefined) $0f13fd461faec947$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $0f13fd461faec947$var$isRegExp(expected[key]) && $0f13fd461faec947$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $0f13fd461faec947$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $0f13fd461faec947$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $0f13fd461faec947$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $0f13fd461faec947$var$NO_EXCEPTION_SENTINEL;
}
function $0f13fd461faec947$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $0f13fd461faec947$var$isPromise(obj) || obj !== null && $0f13fd461faec947$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $0f13fd461faec947$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$0f13fd461faec947$var$checkIsPromise(resultPromise)) throw new $0f13fd461faec947$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($0f13fd461faec947$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $0f13fd461faec947$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $0f13fd461faec947$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $0f13fd461faec947$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $0f13fd461faec947$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($0f13fd461faec947$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $0f13fd461faec947$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $0f13fd461faec947$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $0f13fd461faec947$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $0f13fd461faec947$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $0f13fd461faec947$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $0f13fd461faec947$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$0f13fd461faec947$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $0f13fd461faec947$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $0f13fd461faec947$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $0f13fd461faec947$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $0f13fd461faec947$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$0f13fd461faec947$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $0f13fd461faec947$var$expectsError.apply(void 0, [
        throws,
        $0f13fd461faec947$var$getActual(promiseFn)
    ].concat(args));
};
$0f13fd461faec947$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $0f13fd461faec947$var$waitForActual(promiseFn).then(function(result) {
        return $0f13fd461faec947$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$0f13fd461faec947$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $0f13fd461faec947$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $0f13fd461faec947$var$getActual(fn)
    ].concat(args));
};
$0f13fd461faec947$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $0f13fd461faec947$var$waitForActual(fn).then(function(result) {
        return $0f13fd461faec947$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$0f13fd461faec947$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($0f13fd461faec947$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $0f13fd461faec947$var$inspect(err);
        var newErr = new $jMexq({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $0f13fd461faec947$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$0f13fd461faec947$var$isRegExp(regexp)) throw new $0f13fd461faec947$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $0f13fd461faec947$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($0f13fd461faec947$var$_typeof(string), " (").concat($0f13fd461faec947$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($0f13fd461faec947$var$inspect(regexp), ". Input:\n\n").concat($0f13fd461faec947$var$inspect(string), "\n"));
        var err = new $jMexq({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$0f13fd461faec947$var$assert.match = function match(string, regexp, message) {
    $0f13fd461faec947$var$internalMatch(string, regexp, message, match, 'match');
};
$0f13fd461faec947$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $0f13fd461faec947$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $0f13fd461faec947$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $0f13fd461faec947$var$innerOk.apply(void 0, [
        $0f13fd461faec947$var$strict,
        args.length
    ].concat(args));
}
$0f13fd461faec947$var$assert.strict = $0f13fd461faec947$var$objectAssign($0f13fd461faec947$var$strict, $0f13fd461faec947$var$assert, {
    equal: $0f13fd461faec947$var$assert.strictEqual,
    deepEqual: $0f13fd461faec947$var$assert.deepStrictEqual,
    notEqual: $0f13fd461faec947$var$assert.notStrictEqual,
    notDeepEqual: $0f13fd461faec947$var$assert.notDeepStrictEqual
});
$0f13fd461faec947$var$assert.strict.strict = $0f13fd461faec947$var$assert.strict;

});
parcelRegister("6IF0i", function(module, exports) {
// shim for using process in browser
var $01433444b912d4c8$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $01433444b912d4c8$var$cachedSetTimeout;
var $01433444b912d4c8$var$cachedClearTimeout;
function $01433444b912d4c8$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $01433444b912d4c8$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $01433444b912d4c8$var$cachedSetTimeout = setTimeout;
        else $01433444b912d4c8$var$cachedSetTimeout = $01433444b912d4c8$var$defaultSetTimout;
    } catch (e) {
        $01433444b912d4c8$var$cachedSetTimeout = $01433444b912d4c8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $01433444b912d4c8$var$cachedClearTimeout = clearTimeout;
        else $01433444b912d4c8$var$cachedClearTimeout = $01433444b912d4c8$var$defaultClearTimeout;
    } catch (e) {
        $01433444b912d4c8$var$cachedClearTimeout = $01433444b912d4c8$var$defaultClearTimeout;
    }
})();
function $01433444b912d4c8$var$runTimeout(fun) {
    if ($01433444b912d4c8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($01433444b912d4c8$var$cachedSetTimeout === $01433444b912d4c8$var$defaultSetTimout || !$01433444b912d4c8$var$cachedSetTimeout) && setTimeout) {
        $01433444b912d4c8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $01433444b912d4c8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $01433444b912d4c8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $01433444b912d4c8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $01433444b912d4c8$var$runClearTimeout(marker) {
    if ($01433444b912d4c8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($01433444b912d4c8$var$cachedClearTimeout === $01433444b912d4c8$var$defaultClearTimeout || !$01433444b912d4c8$var$cachedClearTimeout) && clearTimeout) {
        $01433444b912d4c8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $01433444b912d4c8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $01433444b912d4c8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $01433444b912d4c8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $01433444b912d4c8$var$queue = [];
var $01433444b912d4c8$var$draining = false;
var $01433444b912d4c8$var$currentQueue;
var $01433444b912d4c8$var$queueIndex = -1;
function $01433444b912d4c8$var$cleanUpNextTick() {
    if (!$01433444b912d4c8$var$draining || !$01433444b912d4c8$var$currentQueue) return;
    $01433444b912d4c8$var$draining = false;
    if ($01433444b912d4c8$var$currentQueue.length) $01433444b912d4c8$var$queue = $01433444b912d4c8$var$currentQueue.concat($01433444b912d4c8$var$queue);
    else $01433444b912d4c8$var$queueIndex = -1;
    if ($01433444b912d4c8$var$queue.length) $01433444b912d4c8$var$drainQueue();
}
function $01433444b912d4c8$var$drainQueue() {
    if ($01433444b912d4c8$var$draining) return;
    var timeout = $01433444b912d4c8$var$runTimeout($01433444b912d4c8$var$cleanUpNextTick);
    $01433444b912d4c8$var$draining = true;
    var len = $01433444b912d4c8$var$queue.length;
    while(len){
        $01433444b912d4c8$var$currentQueue = $01433444b912d4c8$var$queue;
        $01433444b912d4c8$var$queue = [];
        while(++$01433444b912d4c8$var$queueIndex < len)if ($01433444b912d4c8$var$currentQueue) $01433444b912d4c8$var$currentQueue[$01433444b912d4c8$var$queueIndex].run();
        $01433444b912d4c8$var$queueIndex = -1;
        len = $01433444b912d4c8$var$queue.length;
    }
    $01433444b912d4c8$var$currentQueue = null;
    $01433444b912d4c8$var$draining = false;
    $01433444b912d4c8$var$runClearTimeout(timeout);
}
$01433444b912d4c8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $01433444b912d4c8$var$queue.push(new $01433444b912d4c8$var$Item(fun, args));
    if ($01433444b912d4c8$var$queue.length === 1 && !$01433444b912d4c8$var$draining) $01433444b912d4c8$var$runTimeout($01433444b912d4c8$var$drainQueue);
};
// v8 likes predictible objects
function $01433444b912d4c8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$01433444b912d4c8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$01433444b912d4c8$var$process.title = 'browser';
$01433444b912d4c8$var$process.browser = true;
$01433444b912d4c8$var$process.env = {};
$01433444b912d4c8$var$process.argv = [];
$01433444b912d4c8$var$process.version = ''; // empty string to avoid regexp issues
$01433444b912d4c8$var$process.versions = {};
function $01433444b912d4c8$var$noop() {}
$01433444b912d4c8$var$process.on = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.addListener = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.once = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.off = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.removeListener = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.removeAllListeners = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.emit = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.prependListener = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.prependOnceListener = $01433444b912d4c8$var$noop;
$01433444b912d4c8$var$process.listeners = function(name) {
    return [];
};
$01433444b912d4c8$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$01433444b912d4c8$var$process.cwd = function() {
    return '/';
};
$01433444b912d4c8$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$01433444b912d4c8$var$process.umask = function() {
    return 0;
};

});

parcelRegister("b5toe", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $8126f58f45c12ca3$export$e45cb6485273080e; }, function (v) { return $8126f58f45c12ca3$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $8126f58f45c12ca3$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $8126f58f45c12ca3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8126f58f45c12ca3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8126f58f45c12ca3$var$_typeof(o);
}
function $8126f58f45c12ca3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8126f58f45c12ca3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8126f58f45c12ca3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8126f58f45c12ca3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8126f58f45c12ca3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8126f58f45c12ca3$var$_toPropertyKey(arg) {
    var key = $8126f58f45c12ca3$var$_toPrimitive(arg, "string");
    return $8126f58f45c12ca3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8126f58f45c12ca3$var$_toPrimitive(input, hint) {
    if ($8126f58f45c12ca3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8126f58f45c12ca3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8126f58f45c12ca3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8126f58f45c12ca3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8126f58f45c12ca3$var$_setPrototypeOf(subClass, superClass);
}
function $8126f58f45c12ca3$var$_setPrototypeOf(o, p) {
    $8126f58f45c12ca3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8126f58f45c12ca3$var$_setPrototypeOf(o, p);
}
function $8126f58f45c12ca3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8126f58f45c12ca3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8126f58f45c12ca3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8126f58f45c12ca3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8126f58f45c12ca3$var$_possibleConstructorReturn(this, result);
    };
}
function $8126f58f45c12ca3$var$_possibleConstructorReturn(self, call) {
    if (call && ($8126f58f45c12ca3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8126f58f45c12ca3$var$_assertThisInitialized(self);
}
function $8126f58f45c12ca3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8126f58f45c12ca3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8126f58f45c12ca3$var$_getPrototypeOf(o) {
    $8126f58f45c12ca3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8126f58f45c12ca3$var$_getPrototypeOf(o);
}
var $8126f58f45c12ca3$var$codes = {};
// Lazy loaded
var $8126f58f45c12ca3$var$assert;
var $8126f58f45c12ca3$var$util;
function $8126f58f45c12ca3$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $8126f58f45c12ca3$var$_inherits(NodeError, _Base);
        var _super = $8126f58f45c12ca3$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $8126f58f45c12ca3$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $8126f58f45c12ca3$var$_createClass(NodeError);
    }(Base);
    $8126f58f45c12ca3$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $8126f58f45c12ca3$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $8126f58f45c12ca3$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $8126f58f45c12ca3$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $8126f58f45c12ca3$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$8126f58f45c12ca3$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$8126f58f45c12ca3$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($8126f58f45c12ca3$var$assert === undefined) $8126f58f45c12ca3$var$assert = (parcelRequire("1ig8x"));
    $8126f58f45c12ca3$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $8126f58f45c12ca3$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($8126f58f45c12ca3$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($8126f58f45c12ca3$var$oneOf(expected, 'type'));
    else {
        var type = $8126f58f45c12ca3$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($8126f58f45c12ca3$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($8126f58f45c12ca3$var$_typeof(actual));
    return msg;
}, TypeError);

$8126f58f45c12ca3$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($8126f58f45c12ca3$var$util === undefined) $8126f58f45c12ca3$var$util = (parcelRequire("1TaSd"));
    var inspected = $8126f58f45c12ca3$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$8126f58f45c12ca3$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($8126f58f45c12ca3$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$8126f58f45c12ca3$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($8126f58f45c12ca3$var$assert === undefined) $8126f58f45c12ca3$var$assert = (parcelRequire("1ig8x"));
    $8126f58f45c12ca3$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$8126f58f45c12ca3$export$e45cb6485273080e = $8126f58f45c12ca3$var$codes;

});
parcelRegister("1TaSd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $6IF0i = parcelRequire("6IF0i");
var $16035cb9ef47931c$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $16035cb9ef47931c$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$16035cb9ef47931c$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($16035cb9ef47931c$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($16035cb9ef47931c$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($16035cb9ef47931c$var$isNull(x) || !$16035cb9ef47931c$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $16035cb9ef47931c$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($6IF0i.throwDeprecation) throw new Error(msg);
            else if ($6IF0i.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $16035cb9ef47931c$var$debugs = {};
var $16035cb9ef47931c$var$debugEnvRegex = /^$/;
var $16035cb9ef47931c$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$16035cb9ef47931c$var$debugs[set]) {
        if ($16035cb9ef47931c$var$debugEnvRegex.test(set)) {
            var pid = $6IF0i.pid;
            $16035cb9ef47931c$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $16035cb9ef47931c$var$debugs[set] = function() {};
    }
    return $16035cb9ef47931c$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $16035cb9ef47931c$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $16035cb9ef47931c$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($16035cb9ef47931c$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($16035cb9ef47931c$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($16035cb9ef47931c$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($16035cb9ef47931c$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($16035cb9ef47931c$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $16035cb9ef47931c$var$stylizeWithColor;
    return $16035cb9ef47931c$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $16035cb9ef47931c$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$16035cb9ef47931c$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$16035cb9ef47931c$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $16035cb9ef47931c$var$stylizeWithColor(str, styleType) {
    var style = $16035cb9ef47931c$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $16035cb9ef47931c$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $16035cb9ef47931c$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $16035cb9ef47931c$var$stylizeNoColor(str, styleType) {
    return str;
}
function $16035cb9ef47931c$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $16035cb9ef47931c$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $16035cb9ef47931c$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$16035cb9ef47931c$var$isString(ret)) ret = $16035cb9ef47931c$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $16035cb9ef47931c$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $16035cb9ef47931c$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($16035cb9ef47931c$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $16035cb9ef47931c$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($16035cb9ef47931c$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($16035cb9ef47931c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($16035cb9ef47931c$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($16035cb9ef47931c$var$isError(value)) return $16035cb9ef47931c$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($16035cb9ef47931c$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($16035cb9ef47931c$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($16035cb9ef47931c$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($16035cb9ef47931c$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($16035cb9ef47931c$var$isError(value)) base = ' ' + $16035cb9ef47931c$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($16035cb9ef47931c$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $16035cb9ef47931c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $16035cb9ef47931c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $16035cb9ef47931c$var$reduceToSingleString(output, base, braces);
}
function $16035cb9ef47931c$var$formatPrimitive(ctx, value) {
    if ($16035cb9ef47931c$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($16035cb9ef47931c$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($16035cb9ef47931c$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($16035cb9ef47931c$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($16035cb9ef47931c$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $16035cb9ef47931c$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $16035cb9ef47931c$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($16035cb9ef47931c$var$hasOwnProperty(value, String(i))) output.push($16035cb9ef47931c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($16035cb9ef47931c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $16035cb9ef47931c$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$16035cb9ef47931c$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($16035cb9ef47931c$var$isNull(recurseTimes)) str = $16035cb9ef47931c$var$formatValue(ctx, desc.value, null);
            else str = $16035cb9ef47931c$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($16035cb9ef47931c$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $16035cb9ef47931c$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("kEscw"));
function $16035cb9ef47931c$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $16035cb9ef47931c$var$isArray;
function $16035cb9ef47931c$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $16035cb9ef47931c$var$isBoolean;
function $16035cb9ef47931c$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $16035cb9ef47931c$var$isNull;
function $16035cb9ef47931c$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $16035cb9ef47931c$var$isNullOrUndefined;
function $16035cb9ef47931c$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $16035cb9ef47931c$var$isNumber;
function $16035cb9ef47931c$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $16035cb9ef47931c$var$isString;
function $16035cb9ef47931c$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $16035cb9ef47931c$var$isSymbol;
function $16035cb9ef47931c$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $16035cb9ef47931c$var$isUndefined;
function $16035cb9ef47931c$var$isRegExp(re) {
    return $16035cb9ef47931c$var$isObject(re) && $16035cb9ef47931c$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $16035cb9ef47931c$var$isRegExp;
module.exports.types.isRegExp = $16035cb9ef47931c$var$isRegExp;
function $16035cb9ef47931c$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $16035cb9ef47931c$var$isObject;
function $16035cb9ef47931c$var$isDate(d) {
    return $16035cb9ef47931c$var$isObject(d) && $16035cb9ef47931c$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $16035cb9ef47931c$var$isDate;
module.exports.types.isDate = $16035cb9ef47931c$var$isDate;
function $16035cb9ef47931c$var$isError(e) {
    return $16035cb9ef47931c$var$isObject(e) && ($16035cb9ef47931c$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $16035cb9ef47931c$var$isError;
module.exports.types.isNativeError = $16035cb9ef47931c$var$isError;
function $16035cb9ef47931c$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $16035cb9ef47931c$var$isFunction;
function $16035cb9ef47931c$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $16035cb9ef47931c$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("bk4OD"));
function $16035cb9ef47931c$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $16035cb9ef47931c$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $16035cb9ef47931c$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $16035cb9ef47931c$var$timestamp() {
    var d = new Date();
    var time = [
        $16035cb9ef47931c$var$pad(d.getHours()),
        $16035cb9ef47931c$var$pad(d.getMinutes()),
        $16035cb9ef47931c$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $16035cb9ef47931c$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $16035cb9ef47931c$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("hQMuH"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$16035cb9ef47931c$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $16035cb9ef47931c$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $16035cb9ef47931c$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($16035cb9ef47931c$var$kCustomPromisifiedSymbol && original[$16035cb9ef47931c$var$kCustomPromisifiedSymbol]) {
        var fn = original[$16035cb9ef47931c$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $16035cb9ef47931c$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($16035cb9ef47931c$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $16035cb9ef47931c$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $16035cb9ef47931c$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $16035cb9ef47931c$var$kCustomPromisifiedSymbol;
function $16035cb9ef47931c$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $16035cb9ef47931c$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $6IF0i.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $6IF0i.nextTick($16035cb9ef47931c$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $16035cb9ef47931c$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $16035cb9ef47931c$var$callbackify;

});
parcelRegister("kEscw", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $lwzaY = parcelRequire("lwzaY");

var $eqYtW = parcelRequire("eqYtW");

var $7nk7K = parcelRequire("7nk7K");

var $7PGCL = parcelRequire("7PGCL");
function $03e13faa312aeb26$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $03e13faa312aeb26$var$BigIntSupported = typeof BigInt !== 'undefined';
var $03e13faa312aeb26$var$SymbolSupported = typeof Symbol !== 'undefined';
var $03e13faa312aeb26$var$ObjectToString = $03e13faa312aeb26$var$uncurryThis(Object.prototype.toString);
var $03e13faa312aeb26$var$numberValue = $03e13faa312aeb26$var$uncurryThis(Number.prototype.valueOf);
var $03e13faa312aeb26$var$stringValue = $03e13faa312aeb26$var$uncurryThis(String.prototype.valueOf);
var $03e13faa312aeb26$var$booleanValue = $03e13faa312aeb26$var$uncurryThis(Boolean.prototype.valueOf);
if ($03e13faa312aeb26$var$BigIntSupported) var $03e13faa312aeb26$var$bigIntValue = $03e13faa312aeb26$var$uncurryThis(BigInt.prototype.valueOf);
if ($03e13faa312aeb26$var$SymbolSupported) var $03e13faa312aeb26$var$symbolValue = $03e13faa312aeb26$var$uncurryThis(Symbol.prototype.valueOf);
function $03e13faa312aeb26$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $lwzaY;
module.exports.isGeneratorFunction = $eqYtW;
module.exports.isTypedArray = $7PGCL;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $03e13faa312aeb26$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $03e13faa312aeb26$var$isPromise;
function $03e13faa312aeb26$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $7PGCL(value) || $03e13faa312aeb26$var$isDataView(value);
}
module.exports.isArrayBufferView = $03e13faa312aeb26$var$isArrayBufferView;
function $03e13faa312aeb26$var$isUint8Array(value) {
    return $7nk7K(value) === 'Uint8Array';
}
module.exports.isUint8Array = $03e13faa312aeb26$var$isUint8Array;
function $03e13faa312aeb26$var$isUint8ClampedArray(value) {
    return $7nk7K(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $03e13faa312aeb26$var$isUint8ClampedArray;
function $03e13faa312aeb26$var$isUint16Array(value) {
    return $7nk7K(value) === 'Uint16Array';
}
module.exports.isUint16Array = $03e13faa312aeb26$var$isUint16Array;
function $03e13faa312aeb26$var$isUint32Array(value) {
    return $7nk7K(value) === 'Uint32Array';
}
module.exports.isUint32Array = $03e13faa312aeb26$var$isUint32Array;
function $03e13faa312aeb26$var$isInt8Array(value) {
    return $7nk7K(value) === 'Int8Array';
}
module.exports.isInt8Array = $03e13faa312aeb26$var$isInt8Array;
function $03e13faa312aeb26$var$isInt16Array(value) {
    return $7nk7K(value) === 'Int16Array';
}
module.exports.isInt16Array = $03e13faa312aeb26$var$isInt16Array;
function $03e13faa312aeb26$var$isInt32Array(value) {
    return $7nk7K(value) === 'Int32Array';
}
module.exports.isInt32Array = $03e13faa312aeb26$var$isInt32Array;
function $03e13faa312aeb26$var$isFloat32Array(value) {
    return $7nk7K(value) === 'Float32Array';
}
module.exports.isFloat32Array = $03e13faa312aeb26$var$isFloat32Array;
function $03e13faa312aeb26$var$isFloat64Array(value) {
    return $7nk7K(value) === 'Float64Array';
}
module.exports.isFloat64Array = $03e13faa312aeb26$var$isFloat64Array;
function $03e13faa312aeb26$var$isBigInt64Array(value) {
    return $7nk7K(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $03e13faa312aeb26$var$isBigInt64Array;
function $03e13faa312aeb26$var$isBigUint64Array(value) {
    return $7nk7K(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $03e13faa312aeb26$var$isBigUint64Array;
function $03e13faa312aeb26$var$isMapToString(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object Map]';
}
$03e13faa312aeb26$var$isMapToString.working = typeof Map !== 'undefined' && $03e13faa312aeb26$var$isMapToString(new Map());
function $03e13faa312aeb26$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $03e13faa312aeb26$var$isMapToString.working ? $03e13faa312aeb26$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $03e13faa312aeb26$var$isMap;
function $03e13faa312aeb26$var$isSetToString(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object Set]';
}
$03e13faa312aeb26$var$isSetToString.working = typeof Set !== 'undefined' && $03e13faa312aeb26$var$isSetToString(new Set());
function $03e13faa312aeb26$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $03e13faa312aeb26$var$isSetToString.working ? $03e13faa312aeb26$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $03e13faa312aeb26$var$isSet;
function $03e13faa312aeb26$var$isWeakMapToString(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object WeakMap]';
}
$03e13faa312aeb26$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $03e13faa312aeb26$var$isWeakMapToString(new WeakMap());
function $03e13faa312aeb26$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $03e13faa312aeb26$var$isWeakMapToString.working ? $03e13faa312aeb26$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $03e13faa312aeb26$var$isWeakMap;
function $03e13faa312aeb26$var$isWeakSetToString(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object WeakSet]';
}
$03e13faa312aeb26$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $03e13faa312aeb26$var$isWeakSetToString(new WeakSet());
function $03e13faa312aeb26$var$isWeakSet(value) {
    return $03e13faa312aeb26$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $03e13faa312aeb26$var$isWeakSet;
function $03e13faa312aeb26$var$isArrayBufferToString(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$03e13faa312aeb26$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $03e13faa312aeb26$var$isArrayBufferToString(new ArrayBuffer());
function $03e13faa312aeb26$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $03e13faa312aeb26$var$isArrayBufferToString.working ? $03e13faa312aeb26$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $03e13faa312aeb26$var$isArrayBuffer;
function $03e13faa312aeb26$var$isDataViewToString(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object DataView]';
}
$03e13faa312aeb26$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $03e13faa312aeb26$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $03e13faa312aeb26$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $03e13faa312aeb26$var$isDataViewToString.working ? $03e13faa312aeb26$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $03e13faa312aeb26$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $03e13faa312aeb26$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $03e13faa312aeb26$var$isSharedArrayBufferToString(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $03e13faa312aeb26$var$isSharedArrayBuffer(value) {
    if (typeof $03e13faa312aeb26$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $03e13faa312aeb26$var$isSharedArrayBufferToString.working === 'undefined') $03e13faa312aeb26$var$isSharedArrayBufferToString.working = $03e13faa312aeb26$var$isSharedArrayBufferToString(new $03e13faa312aeb26$var$SharedArrayBufferCopy());
    return $03e13faa312aeb26$var$isSharedArrayBufferToString.working ? $03e13faa312aeb26$var$isSharedArrayBufferToString(value) : value instanceof $03e13faa312aeb26$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $03e13faa312aeb26$var$isSharedArrayBuffer;
function $03e13faa312aeb26$var$isAsyncFunction(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $03e13faa312aeb26$var$isAsyncFunction;
function $03e13faa312aeb26$var$isMapIterator(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $03e13faa312aeb26$var$isMapIterator;
function $03e13faa312aeb26$var$isSetIterator(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $03e13faa312aeb26$var$isSetIterator;
function $03e13faa312aeb26$var$isGeneratorObject(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $03e13faa312aeb26$var$isGeneratorObject;
function $03e13faa312aeb26$var$isWebAssemblyCompiledModule(value) {
    return $03e13faa312aeb26$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $03e13faa312aeb26$var$isWebAssemblyCompiledModule;
function $03e13faa312aeb26$var$isNumberObject(value) {
    return $03e13faa312aeb26$var$checkBoxedPrimitive(value, $03e13faa312aeb26$var$numberValue);
}
module.exports.isNumberObject = $03e13faa312aeb26$var$isNumberObject;
function $03e13faa312aeb26$var$isStringObject(value) {
    return $03e13faa312aeb26$var$checkBoxedPrimitive(value, $03e13faa312aeb26$var$stringValue);
}
module.exports.isStringObject = $03e13faa312aeb26$var$isStringObject;
function $03e13faa312aeb26$var$isBooleanObject(value) {
    return $03e13faa312aeb26$var$checkBoxedPrimitive(value, $03e13faa312aeb26$var$booleanValue);
}
module.exports.isBooleanObject = $03e13faa312aeb26$var$isBooleanObject;
function $03e13faa312aeb26$var$isBigIntObject(value) {
    return $03e13faa312aeb26$var$BigIntSupported && $03e13faa312aeb26$var$checkBoxedPrimitive(value, $03e13faa312aeb26$var$bigIntValue);
}
module.exports.isBigIntObject = $03e13faa312aeb26$var$isBigIntObject;
function $03e13faa312aeb26$var$isSymbolObject(value) {
    return $03e13faa312aeb26$var$SymbolSupported && $03e13faa312aeb26$var$checkBoxedPrimitive(value, $03e13faa312aeb26$var$symbolValue);
}
module.exports.isSymbolObject = $03e13faa312aeb26$var$isSymbolObject;
function $03e13faa312aeb26$var$isBoxedPrimitive(value) {
    return $03e13faa312aeb26$var$isNumberObject(value) || $03e13faa312aeb26$var$isStringObject(value) || $03e13faa312aeb26$var$isBooleanObject(value) || $03e13faa312aeb26$var$isBigIntObject(value) || $03e13faa312aeb26$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $03e13faa312aeb26$var$isBoxedPrimitive;
function $03e13faa312aeb26$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($03e13faa312aeb26$var$isArrayBuffer(value) || $03e13faa312aeb26$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $03e13faa312aeb26$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("lwzaY", function(module, exports) {
'use strict';

var $fab7df60c2e576b4$var$hasToStringTag = (parcelRequire("1oMQC"))();

var $h7gx1 = parcelRequire("h7gx1");
var $fab7df60c2e576b4$var$$toString = $h7gx1('Object.prototype.toString');
/** @type {import('.')} */ var $fab7df60c2e576b4$var$isStandardArguments = function isArguments(value) {
    if ($fab7df60c2e576b4$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $fab7df60c2e576b4$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $fab7df60c2e576b4$var$isLegacyArguments = function isArguments(value) {
    if ($fab7df60c2e576b4$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $fab7df60c2e576b4$var$$toString(value) !== '[object Array]' && 'callee' in value && $fab7df60c2e576b4$var$$toString(value.callee) === '[object Function]';
};
var $fab7df60c2e576b4$var$supportsStandardArguments = function() {
    return $fab7df60c2e576b4$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$fab7df60c2e576b4$var$isStandardArguments.isLegacyArguments = $fab7df60c2e576b4$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $fab7df60c2e576b4$var$supportsStandardArguments ? $fab7df60c2e576b4$var$isStandardArguments : $fab7df60c2e576b4$var$isLegacyArguments;

});
parcelRegister("1oMQC", function(module, exports) {
'use strict';

var $gAwoP = parcelRequire("gAwoP");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $gAwoP() && !!Symbol.toStringTag;
};

});
parcelRegister("gAwoP", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("h7gx1", function(module, exports) {
'use strict';

var $eTCGQ = parcelRequire("eTCGQ");

var $98XoW = parcelRequire("98XoW");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $c75fe9f74f25cd58$var$$indexOf = $98XoW([
    $eTCGQ('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $eTCGQ(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $c75fe9f74f25cd58$var$$indexOf(name, '.prototype.') > -1) return $98XoW(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("eTCGQ", function(module, exports) {
'use strict';
var $ad8436c85430b624$var$undefined1;

var $1tCdg = parcelRequire("1tCdg");

var $16l6G = parcelRequire("16l6G");

var $aFVBK = parcelRequire("aFVBK");

var $aluOS = parcelRequire("aluOS");

var $kFjMj = parcelRequire("kFjMj");

var $2FAJm = parcelRequire("2FAJm");

var $bkYCh = parcelRequire("bkYCh");

var $4chwC = parcelRequire("4chwC");

var $6eYiN = parcelRequire("6eYiN");

var $aQXsz = parcelRequire("aQXsz");

var $jomIF = parcelRequire("jomIF");

var $4Js7p = parcelRequire("4Js7p");

var $60IRz = parcelRequire("60IRz");

var $5G2jw = parcelRequire("5G2jw");

var $h2m2O = parcelRequire("h2m2O");
var $ad8436c85430b624$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $ad8436c85430b624$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $ad8436c85430b624$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $kLde1 = parcelRequire("kLde1");

var $cEP6s = parcelRequire("cEP6s");
var $ad8436c85430b624$var$throwTypeError = function() {
    throw new $bkYCh();
};
var $ad8436c85430b624$var$ThrowTypeError = $kLde1 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $ad8436c85430b624$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $kLde1(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $ad8436c85430b624$var$throwTypeError;
        }
    }
}() : $ad8436c85430b624$var$throwTypeError;

var $ad8436c85430b624$var$hasSymbols = (parcelRequire("fG4Yk"))();

var $jY6fR = parcelRequire("jY6fR");

var $40gdz = parcelRequire("40gdz");

var $2Ozr7 = parcelRequire("2Ozr7");

var $iqErU = parcelRequire("iqErU");

var $iF38p = parcelRequire("iF38p");
var $ad8436c85430b624$var$needsEval = {};
var $ad8436c85430b624$var$TypedArray = typeof Uint8Array === 'undefined' || !$jY6fR ? undefined : $jY6fR(Uint8Array);
var $ad8436c85430b624$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $ad8436c85430b624$var$hasSymbols && $jY6fR ? $jY6fR([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $ad8436c85430b624$var$needsEval,
    '%AsyncGenerator%': $ad8436c85430b624$var$needsEval,
    '%AsyncGeneratorFunction%': $ad8436c85430b624$var$needsEval,
    '%AsyncIteratorPrototype%': $ad8436c85430b624$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $16l6G,
    '%eval%': eval,
    '%EvalError%': $aFVBK,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $ad8436c85430b624$var$$Function,
    '%GeneratorFunction%': $ad8436c85430b624$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $ad8436c85430b624$var$hasSymbols && $jY6fR ? $jY6fR($jY6fR([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$ad8436c85430b624$var$hasSymbols || !$jY6fR ? undefined : $jY6fR(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $1tCdg,
    '%Object.getOwnPropertyDescriptor%': $kLde1,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $aluOS,
    '%ReferenceError%': $kFjMj,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$ad8436c85430b624$var$hasSymbols || !$jY6fR ? undefined : $jY6fR(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $ad8436c85430b624$var$hasSymbols && $jY6fR ? $jY6fR(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $ad8436c85430b624$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $2FAJm,
    '%ThrowTypeError%': $ad8436c85430b624$var$ThrowTypeError,
    '%TypedArray%': $ad8436c85430b624$var$TypedArray,
    '%TypeError%': $bkYCh,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $4chwC,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $iF38p,
    '%Function.prototype.apply%': $iqErU,
    '%Object.defineProperty%': $cEP6s,
    '%Object.getPrototypeOf%': $40gdz,
    '%Math.abs%': $6eYiN,
    '%Math.floor%': $aQXsz,
    '%Math.max%': $jomIF,
    '%Math.min%': $4Js7p,
    '%Math.pow%': $60IRz,
    '%Math.round%': $5G2jw,
    '%Math.sign%': $h2m2O,
    '%Reflect.getPrototypeOf%': $2Ozr7
};
if ($jY6fR) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $ad8436c85430b624$var$errorProto = $jY6fR($jY6fR(e));
    $ad8436c85430b624$var$INTRINSICS['%Error.prototype%'] = $ad8436c85430b624$var$errorProto;
}
var $ad8436c85430b624$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $ad8436c85430b624$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $ad8436c85430b624$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $ad8436c85430b624$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $jY6fR) value = $jY6fR(gen.prototype);
    }
    $ad8436c85430b624$var$INTRINSICS[name] = value;
    return value;
};
var $ad8436c85430b624$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $ioJc8 = parcelRequire("ioJc8");

var $cU7w2 = parcelRequire("cU7w2");
var $ad8436c85430b624$var$$concat = $ioJc8.call($iF38p, Array.prototype.concat);
var $ad8436c85430b624$var$$spliceApply = $ioJc8.call($iqErU, Array.prototype.splice);
var $ad8436c85430b624$var$$replace = $ioJc8.call($iF38p, String.prototype.replace);
var $ad8436c85430b624$var$$strSlice = $ioJc8.call($iF38p, String.prototype.slice);
var $ad8436c85430b624$var$$exec = $ioJc8.call($iF38p, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $ad8436c85430b624$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $ad8436c85430b624$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $ad8436c85430b624$var$stringToPath = function stringToPath(string) {
    var first = $ad8436c85430b624$var$$strSlice(string, 0, 1);
    var last = $ad8436c85430b624$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $2FAJm('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $2FAJm('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $ad8436c85430b624$var$$replace(string, $ad8436c85430b624$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $ad8436c85430b624$var$$replace(subString, $ad8436c85430b624$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $ad8436c85430b624$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($cU7w2($ad8436c85430b624$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $ad8436c85430b624$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($cU7w2($ad8436c85430b624$var$INTRINSICS, intrinsicName)) {
        var value = $ad8436c85430b624$var$INTRINSICS[intrinsicName];
        if (value === $ad8436c85430b624$var$needsEval) value = $ad8436c85430b624$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $bkYCh('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $2FAJm('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $bkYCh('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $bkYCh('"allowMissing" argument must be a boolean');
    if ($ad8436c85430b624$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $2FAJm('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $ad8436c85430b624$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $ad8436c85430b624$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $ad8436c85430b624$var$$spliceApply(parts, $ad8436c85430b624$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $ad8436c85430b624$var$$strSlice(part, 0, 1);
        var last = $ad8436c85430b624$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $2FAJm('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($cU7w2($ad8436c85430b624$var$INTRINSICS, intrinsicRealName)) value = $ad8436c85430b624$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bkYCh('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($kLde1 && i + 1 >= parts.length) {
                var desc = $kLde1(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $cU7w2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $ad8436c85430b624$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("1tCdg", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("16l6G", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("aFVBK", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("aluOS", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("kFjMj", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("2FAJm", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("bkYCh", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("4chwC", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("6eYiN", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("aQXsz", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("jomIF", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4Js7p", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("60IRz", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("5G2jw", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("h2m2O", function(module, exports) {
'use strict';

var $556BK = parcelRequire("556BK");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($556BK(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("556BK", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("kLde1", function(module, exports) {
'use strict';

var $gZswU = parcelRequire("gZswU");
var $f1d274ad3b4ec414$require$$gOPD = $gZswU;
if ($f1d274ad3b4ec414$require$$gOPD) try {
    $f1d274ad3b4ec414$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $f1d274ad3b4ec414$require$$gOPD = null;
}
module.exports = $f1d274ad3b4ec414$require$$gOPD;

});
parcelRegister("gZswU", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("cEP6s", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $9370dc825869dfdf$var$$defineProperty = Object.defineProperty || false;
if ($9370dc825869dfdf$var$$defineProperty) try {
    $9370dc825869dfdf$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $9370dc825869dfdf$var$$defineProperty = false;
}
module.exports = $9370dc825869dfdf$var$$defineProperty;

});

parcelRegister("fG4Yk", function(module, exports) {
'use strict';
var $b69ea29ecc0a83e1$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $gAwoP = parcelRequire("gAwoP");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $b69ea29ecc0a83e1$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $b69ea29ecc0a83e1$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $gAwoP();
};

});

parcelRegister("jY6fR", function(module, exports) {
'use strict';

var $2Ozr7 = parcelRequire("2Ozr7");

var $40gdz = parcelRequire("40gdz");

var $g8T6V = parcelRequire("g8T6V");
/** @type {import('.')} */ module.exports = $2Ozr7 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $2Ozr7(O);
} : $40gdz ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $40gdz(O);
} : $g8T6V ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $g8T6V(O);
} : null;

});
parcelRegister("2Ozr7", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("40gdz", function(module, exports) {
'use strict';

var $1tCdg = parcelRequire("1tCdg");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $1tCdg.getPrototypeOf || null;

});

parcelRegister("g8T6V", function(module, exports) {
'use strict';

var $98XoW = parcelRequire("98XoW");

var $kLde1 = parcelRequire("kLde1");
var $bc08248d1d815ad6$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $bc08248d1d815ad6$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $bc08248d1d815ad6$var$desc = !!$bc08248d1d815ad6$var$hasProtoAccessor && $kLde1 && $kLde1(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $bc08248d1d815ad6$var$$Object = Object;
var $bc08248d1d815ad6$var$$getPrototypeOf = $bc08248d1d815ad6$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $bc08248d1d815ad6$var$desc && typeof $bc08248d1d815ad6$var$desc.get === 'function' ? $98XoW([
    $bc08248d1d815ad6$var$desc.get
]) : typeof $bc08248d1d815ad6$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $bc08248d1d815ad6$var$$getPrototypeOf(value == null ? value : $bc08248d1d815ad6$var$$Object(value));
} : false;

});
parcelRegister("98XoW", function(module, exports) {
'use strict';

var $ioJc8 = parcelRequire("ioJc8");

var $bkYCh = parcelRequire("bkYCh");

var $iF38p = parcelRequire("iF38p");

var $eEH9B = parcelRequire("eEH9B");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $bkYCh('a function is required');
    return $eEH9B($ioJc8, $iF38p, args);
};

});
parcelRegister("ioJc8", function(module, exports) {
'use strict';

var $2GVMz = parcelRequire("2GVMz");
module.exports = Function.prototype.bind || $2GVMz;

});
parcelRegister("2GVMz", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $1f5c535f33b73cf3$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $1f5c535f33b73cf3$var$toStr = Object.prototype.toString;
var $1f5c535f33b73cf3$var$max = Math.max;
var $1f5c535f33b73cf3$var$funcType = '[object Function]';
var $1f5c535f33b73cf3$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $1f5c535f33b73cf3$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $1f5c535f33b73cf3$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $1f5c535f33b73cf3$var$toStr.apply(target) !== $1f5c535f33b73cf3$var$funcType) throw new TypeError($1f5c535f33b73cf3$var$ERROR_MESSAGE + target);
    var args = $1f5c535f33b73cf3$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $1f5c535f33b73cf3$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $1f5c535f33b73cf3$var$concatty(args, arguments));
    };
    var boundLength = $1f5c535f33b73cf3$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $1f5c535f33b73cf3$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("iF38p", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("eEH9B", function(module, exports) {
'use strict';

var $ioJc8 = parcelRequire("ioJc8");

var $iqErU = parcelRequire("iqErU");

var $iF38p = parcelRequire("iF38p");

var $2wccM = parcelRequire("2wccM");
/** @type {import('./actualApply')} */ module.exports = $2wccM || $ioJc8.call($iF38p, $iqErU);

});
parcelRegister("iqErU", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("2wccM", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("cU7w2", function(module, exports) {
'use strict';
var $96508b7a5cca17e9$var$call = Function.prototype.call;
var $96508b7a5cca17e9$var$$hasOwn = Object.prototype.hasOwnProperty;

var $ioJc8 = parcelRequire("ioJc8");
/** @type {import('.')} */ module.exports = $ioJc8.call($96508b7a5cca17e9$var$call, $96508b7a5cca17e9$var$$hasOwn);

});




parcelRegister("eqYtW", function(module, exports) {
'use strict';

var $h7gx1 = parcelRequire("h7gx1");

var $3d6H4 = parcelRequire("3d6H4");
var $a82268deea9b5b5a$var$isFnRegex = $3d6H4(/^\s*(?:function)?\*/);

var $a82268deea9b5b5a$var$hasToStringTag = (parcelRequire("1oMQC"))();

var $jY6fR = parcelRequire("jY6fR");
var $a82268deea9b5b5a$var$toStr = $h7gx1('Object.prototype.toString');
var $a82268deea9b5b5a$var$fnToStr = $h7gx1('Function.prototype.toString');
var $a82268deea9b5b5a$var$getGeneratorFunc = function() {
    if (!$a82268deea9b5b5a$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
/** @type {undefined | false | null | GeneratorFunctionConstructor} */ var $a82268deea9b5b5a$var$GeneratorFunction;
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($a82268deea9b5b5a$var$isFnRegex($a82268deea9b5b5a$var$fnToStr(fn))) return true;
    if (!$a82268deea9b5b5a$var$hasToStringTag) {
        var str = $a82268deea9b5b5a$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$jY6fR) return false;
    if (typeof $a82268deea9b5b5a$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $a82268deea9b5b5a$var$getGeneratorFunc();
        $a82268deea9b5b5a$var$GeneratorFunction = generatorFunc ? /** @type {GeneratorFunctionConstructor} */ $jY6fR(generatorFunc) : false;
    }
    return $jY6fR(fn) === $a82268deea9b5b5a$var$GeneratorFunction;
};

});
parcelRegister("3d6H4", function(module, exports) {
'use strict';

var $h7gx1 = parcelRequire("h7gx1");

var $kXFCU = parcelRequire("kXFCU");
var $2567c73c3f498f72$var$$exec = $h7gx1('RegExp.prototype.exec');

var $bkYCh = parcelRequire("bkYCh");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$kXFCU(regex)) throw new $bkYCh('`regex` must be a RegExp');
    return function test(s) {
        return $2567c73c3f498f72$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("kXFCU", function(module, exports) {
'use strict';

var $h7gx1 = parcelRequire("h7gx1");

var $f4299b7b9e8788f1$var$hasToStringTag = (parcelRequire("1oMQC"))();

var $cU7w2 = parcelRequire("cU7w2");

var $kLde1 = parcelRequire("kLde1");
/** @type {import('.')} */ var $f4299b7b9e8788f1$var$fn;
if ($f4299b7b9e8788f1$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $f4299b7b9e8788f1$var$$exec = $h7gx1('RegExp.prototype.exec');
    /** @type {object} */ var $f4299b7b9e8788f1$var$isRegexMarker = {};
    var $f4299b7b9e8788f1$var$throwRegexMarker = function() {
        throw $f4299b7b9e8788f1$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $f4299b7b9e8788f1$var$badStringifier = {
        toString: $f4299b7b9e8788f1$var$throwRegexMarker,
        valueOf: $f4299b7b9e8788f1$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $f4299b7b9e8788f1$var$badStringifier[Symbol.toPrimitive] = $f4299b7b9e8788f1$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $f4299b7b9e8788f1$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $kLde1(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $cU7w2(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $f4299b7b9e8788f1$var$$exec(value, /** @type {unknown} */ $f4299b7b9e8788f1$var$badStringifier);
        } catch (e) {
            return e === $f4299b7b9e8788f1$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $f4299b7b9e8788f1$var$$toString = $h7gx1('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $f4299b7b9e8788f1$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $f4299b7b9e8788f1$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $f4299b7b9e8788f1$var$$toString(value) === $f4299b7b9e8788f1$var$regexClass;
    };
}
module.exports = $f4299b7b9e8788f1$var$fn;

});



parcelRegister("7nk7K", function(module, exports) {
'use strict';

var $lJAJD = parcelRequire("lJAJD");

var $gTrn2 = parcelRequire("gTrn2");

var $c8tpS = parcelRequire("c8tpS");

var $h7gx1 = parcelRequire("h7gx1");

var $kLde1 = parcelRequire("kLde1");

var $jY6fR = parcelRequire("jY6fR");
var $55ea4a92ab0ec9c9$var$$toString = $h7gx1('Object.prototype.toString');

var $55ea4a92ab0ec9c9$var$hasToStringTag = (parcelRequire("1oMQC"))();
var $55ea4a92ab0ec9c9$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $55ea4a92ab0ec9c9$var$typedArrays = $gTrn2();
var $55ea4a92ab0ec9c9$var$$slice = $h7gx1('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $55ea4a92ab0ec9c9$var$$indexOf = $h7gx1('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $55ea4a92ab0ec9c9$var$cache = {
    __proto__: null
};
if ($55ea4a92ab0ec9c9$var$hasToStringTag && $kLde1 && $jY6fR) $lJAJD($55ea4a92ab0ec9c9$var$typedArrays, function(typedArray) {
    var arr = new $55ea4a92ab0ec9c9$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $jY6fR) {
        var proto = $jY6fR(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $kLde1(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $jY6fR(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $kLde1(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $55ea4a92ab0ec9c9$var$cache['$' + typedArray] = $c8tpS(descriptor.get);
    }
});
else $lJAJD($55ea4a92ab0ec9c9$var$typedArrays, function(typedArray) {
    var arr = new $55ea4a92ab0ec9c9$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $55ea4a92ab0ec9c9$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $c8tpS(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $55ea4a92ab0ec9c9$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $lJAJD(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $55ea4a92ab0ec9c9$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $55ea4a92ab0ec9c9$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $55ea4a92ab0ec9c9$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $lJAJD(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $55ea4a92ab0ec9c9$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $55ea4a92ab0ec9c9$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$55ea4a92ab0ec9c9$var$hasToStringTag) {
        /** @type {string} */ var tag = $55ea4a92ab0ec9c9$var$$slice($55ea4a92ab0ec9c9$var$$toString(value), 8, -1);
        if ($55ea4a92ab0ec9c9$var$$indexOf($55ea4a92ab0ec9c9$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $55ea4a92ab0ec9c9$var$trySlices(value);
    }
    if (!$kLde1) return null;
     // unknown engine
    return $55ea4a92ab0ec9c9$var$tryTypedArrays(value);
};

});
parcelRegister("lJAJD", function(module, exports) {
'use strict';

var $dMxYE = parcelRequire("dMxYE");
var $fd2a4bbfaf6d5e94$var$toStr = Object.prototype.toString;
var $fd2a4bbfaf6d5e94$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $fd2a4bbfaf6d5e94$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($fd2a4bbfaf6d5e94$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $fd2a4bbfaf6d5e94$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $fd2a4bbfaf6d5e94$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($fd2a4bbfaf6d5e94$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $fd2a4bbfaf6d5e94$var$isArray(x) {
    return $fd2a4bbfaf6d5e94$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$dMxYE(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($fd2a4bbfaf6d5e94$var$isArray(list)) $fd2a4bbfaf6d5e94$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $fd2a4bbfaf6d5e94$var$forEachString(list, iterator, receiver);
    else $fd2a4bbfaf6d5e94$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("dMxYE", function(module, exports) {
'use strict';
var $a08a1d3a2338035e$var$fnToStr = Function.prototype.toString;
var $a08a1d3a2338035e$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $a08a1d3a2338035e$var$badArrayLike;
var $a08a1d3a2338035e$var$isCallableMarker;
if (typeof $a08a1d3a2338035e$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $a08a1d3a2338035e$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $a08a1d3a2338035e$var$isCallableMarker;
        }
    });
    $a08a1d3a2338035e$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $a08a1d3a2338035e$var$reflectApply(function() {
        throw 42;
    }, null, $a08a1d3a2338035e$var$badArrayLike);
} catch (_) {
    if (_ !== $a08a1d3a2338035e$var$isCallableMarker) $a08a1d3a2338035e$var$reflectApply = null;
}
else $a08a1d3a2338035e$var$reflectApply = null;
var $a08a1d3a2338035e$var$constructorRegex = /^\s*class\b/;
var $a08a1d3a2338035e$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $a08a1d3a2338035e$var$fnToStr.call(value);
        return $a08a1d3a2338035e$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $a08a1d3a2338035e$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($a08a1d3a2338035e$var$isES6ClassFn(value)) return false;
        $a08a1d3a2338035e$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $a08a1d3a2338035e$var$toStr = Object.prototype.toString;
var $a08a1d3a2338035e$var$objectClass = '[object Object]';
var $a08a1d3a2338035e$var$fnClass = '[object Function]';
var $a08a1d3a2338035e$var$genClass = '[object GeneratorFunction]';
var $a08a1d3a2338035e$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $a08a1d3a2338035e$var$ddaClass2 = '[object HTML document.all class]';
var $a08a1d3a2338035e$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $a08a1d3a2338035e$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $a08a1d3a2338035e$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $a08a1d3a2338035e$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $a08a1d3a2338035e$var$all = document.all;
    if ($a08a1d3a2338035e$var$toStr.call($a08a1d3a2338035e$var$all) === $a08a1d3a2338035e$var$toStr.call(document.all)) $a08a1d3a2338035e$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($a08a1d3a2338035e$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $a08a1d3a2338035e$var$toStr.call(value);
            return (str === $a08a1d3a2338035e$var$ddaClass || str === $a08a1d3a2338035e$var$ddaClass2 || str === $a08a1d3a2338035e$var$ddaClass3 // opera 12.16
             || str === $a08a1d3a2338035e$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $a08a1d3a2338035e$var$reflectApply ? function isCallable(value) {
    if ($a08a1d3a2338035e$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $a08a1d3a2338035e$var$reflectApply(value, null, $a08a1d3a2338035e$var$badArrayLike);
    } catch (e) {
        if (e !== $a08a1d3a2338035e$var$isCallableMarker) return false;
    }
    return !$a08a1d3a2338035e$var$isES6ClassFn(value) && $a08a1d3a2338035e$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($a08a1d3a2338035e$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($a08a1d3a2338035e$var$hasToStringTag) return $a08a1d3a2338035e$var$tryFunctionObject(value);
    if ($a08a1d3a2338035e$var$isES6ClassFn(value)) return false;
    var strClass = $a08a1d3a2338035e$var$toStr.call(value);
    if (strClass !== $a08a1d3a2338035e$var$fnClass && strClass !== $a08a1d3a2338035e$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $a08a1d3a2338035e$var$tryFunctionObject(value);
};

});


parcelRegister("gTrn2", function(module, exports) {
'use strict';

var $hjqVC = parcelRequire("hjqVC");
var $c4c703a6318b53d9$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $hjqVC.length; i++)if (typeof $c4c703a6318b53d9$var$g[$hjqVC[i]] === 'function') // @ts-expect-error
    out[out.length] = $hjqVC[i];
    return out;
};

});
parcelRegister("hjqVC", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("c8tpS", function(module, exports) {
'use strict';

var $7FKrq = parcelRequire("7FKrq");

var $cEP6s = parcelRequire("cEP6s");

var $98XoW = parcelRequire("98XoW");

var $jmFS3 = parcelRequire("jmFS3");
module.exports = function callBind(originalFunction) {
    var func = $98XoW(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $7FKrq(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($cEP6s) $cEP6s(module.exports, 'apply', {
    value: $jmFS3
});
else module.exports.apply = $jmFS3;

});
parcelRegister("7FKrq", function(module, exports) {
'use strict';

var $eTCGQ = parcelRequire("eTCGQ");

var $4Q3a0 = parcelRequire("4Q3a0");

var $59606305b76a7459$var$hasDescriptors = (parcelRequire("in0nB"))();

var $kLde1 = parcelRequire("kLde1");

var $bkYCh = parcelRequire("bkYCh");
var $59606305b76a7459$var$$floor = $eTCGQ('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $bkYCh('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $59606305b76a7459$var$$floor(length) !== length) throw new $bkYCh('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $kLde1) {
        var desc = $kLde1(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($59606305b76a7459$var$hasDescriptors) $4Q3a0(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $4Q3a0(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("4Q3a0", function(module, exports) {
'use strict';

var $cEP6s = parcelRequire("cEP6s");

var $2FAJm = parcelRequire("2FAJm");

var $bkYCh = parcelRequire("bkYCh");

var $kLde1 = parcelRequire("kLde1");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $bkYCh('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $bkYCh('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $bkYCh('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $bkYCh('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $bkYCh('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $bkYCh('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$kLde1 && $kLde1(obj, property);
    if ($cEP6s) $cEP6s(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $2FAJm('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("in0nB", function(module, exports) {
'use strict';

var $cEP6s = parcelRequire("cEP6s");
var $d5faab59ec436cb8$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$cEP6s;
};
$d5faab59ec436cb8$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$cEP6s) return null;
    try {
        return $cEP6s([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d5faab59ec436cb8$var$hasPropertyDescriptors;

});


parcelRegister("jmFS3", function(module, exports) {
'use strict';

var $ioJc8 = parcelRequire("ioJc8");

var $iqErU = parcelRequire("iqErU");

var $eEH9B = parcelRequire("eEH9B");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $eEH9B($ioJc8, $iqErU, arguments);
};

});



parcelRegister("7PGCL", function(module, exports) {
'use strict';

var $7nk7K = parcelRequire("7nk7K");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$7nk7K(value);
};

});


parcelRegister("bk4OD", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("hQMuH", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("jMexq", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $6IF0i = parcelRequire("6IF0i");
'use strict';
function $e65dc6f7d1659573$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e65dc6f7d1659573$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e65dc6f7d1659573$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e65dc6f7d1659573$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e65dc6f7d1659573$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e65dc6f7d1659573$var$_defineProperty(obj, key, value) {
    key = $e65dc6f7d1659573$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e65dc6f7d1659573$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e65dc6f7d1659573$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e65dc6f7d1659573$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e65dc6f7d1659573$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e65dc6f7d1659573$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e65dc6f7d1659573$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e65dc6f7d1659573$var$_toPropertyKey(arg) {
    var key = $e65dc6f7d1659573$var$_toPrimitive(arg, "string");
    return $e65dc6f7d1659573$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e65dc6f7d1659573$var$_toPrimitive(input, hint) {
    if ($e65dc6f7d1659573$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e65dc6f7d1659573$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e65dc6f7d1659573$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e65dc6f7d1659573$var$_setPrototypeOf(subClass, superClass);
}
function $e65dc6f7d1659573$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e65dc6f7d1659573$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e65dc6f7d1659573$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e65dc6f7d1659573$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e65dc6f7d1659573$var$_possibleConstructorReturn(this, result);
    };
}
function $e65dc6f7d1659573$var$_possibleConstructorReturn(self, call) {
    if (call && ($e65dc6f7d1659573$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e65dc6f7d1659573$var$_assertThisInitialized(self);
}
function $e65dc6f7d1659573$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e65dc6f7d1659573$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e65dc6f7d1659573$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$e65dc6f7d1659573$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $e65dc6f7d1659573$var$_construct(Class, arguments, $e65dc6f7d1659573$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $e65dc6f7d1659573$var$_setPrototypeOf(Wrapper, Class);
    };
    return $e65dc6f7d1659573$var$_wrapNativeSuper(Class);
}
function $e65dc6f7d1659573$var$_construct(Parent, args, Class) {
    if ($e65dc6f7d1659573$var$_isNativeReflectConstruct()) $e65dc6f7d1659573$var$_construct = Reflect.construct.bind();
    else $e65dc6f7d1659573$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $e65dc6f7d1659573$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $e65dc6f7d1659573$var$_construct.apply(null, arguments);
}
function $e65dc6f7d1659573$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e65dc6f7d1659573$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $e65dc6f7d1659573$var$_setPrototypeOf(o, p) {
    $e65dc6f7d1659573$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e65dc6f7d1659573$var$_setPrototypeOf(o, p);
}
function $e65dc6f7d1659573$var$_getPrototypeOf(o) {
    $e65dc6f7d1659573$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e65dc6f7d1659573$var$_getPrototypeOf(o);
}
function $e65dc6f7d1659573$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e65dc6f7d1659573$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e65dc6f7d1659573$var$_typeof(o);
}

var $1TaSd = parcelRequire("1TaSd");
var $e65dc6f7d1659573$var$inspect = $1TaSd.inspect;

var $b5toe = parcelRequire("b5toe");
var $e65dc6f7d1659573$var$ERR_INVALID_ARG_TYPE = $b5toe.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $e65dc6f7d1659573$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $e65dc6f7d1659573$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $e65dc6f7d1659573$var$blue = '';
var $e65dc6f7d1659573$var$green = '';
var $e65dc6f7d1659573$var$red = '';
var $e65dc6f7d1659573$var$white = '';
var $e65dc6f7d1659573$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $e65dc6f7d1659573$var$kMaxShortLength = 10;
function $e65dc6f7d1659573$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $e65dc6f7d1659573$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $e65dc6f7d1659573$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $e65dc6f7d1659573$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $e65dc6f7d1659573$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $e65dc6f7d1659573$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $e65dc6f7d1659573$var$_typeof(actual) === 'object' && $e65dc6f7d1659573$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $e65dc6f7d1659573$var$kMaxShortLength) {
            if (($e65dc6f7d1659573$var$_typeof(actual) !== 'object' || actual === null) && ($e65dc6f7d1659573$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($e65dc6f7d1659573$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $6IF0i.stderr && $6IF0i.stderr.isTTY ? $6IF0i.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($e65dc6f7d1659573$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($e65dc6f7d1659573$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $e65dc6f7d1659573$var$kReadableOperator[operator] + "\n".concat($e65dc6f7d1659573$var$green, "+ actual").concat($e65dc6f7d1659573$var$white, " ").concat($e65dc6f7d1659573$var$red, "- expected").concat($e65dc6f7d1659573$var$white);
    var skippedMsg = " ".concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($e65dc6f7d1659573$var$red, "-").concat($e65dc6f7d1659573$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($e65dc6f7d1659573$var$green, "+").concat($e65dc6f7d1659573$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$e65dc6f7d1659573$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $e65dc6f7d1659573$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($e65dc6f7d1659573$var$green, "+").concat($e65dc6f7d1659573$var$white, " ").concat(actualLine);
                other += "\n".concat($e65dc6f7d1659573$var$red, "-").concat($e65dc6f7d1659573$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white).concat(other, "\n") + "".concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $e65dc6f7d1659573$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $e65dc6f7d1659573$var$_inherits(AssertionError, _Error);
    var _super = $e65dc6f7d1659573$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $e65dc6f7d1659573$var$_classCallCheck(this, AssertionError);
        if ($e65dc6f7d1659573$var$_typeof(options) !== 'object' || options === null) throw new $e65dc6f7d1659573$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($6IF0i.stderr && $6IF0i.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($6IF0i.stderr && $6IF0i.stderr.getColorDepth && $6IF0i.stderr.getColorDepth() !== 1) {
                    $e65dc6f7d1659573$var$blue = "\x1B[34m";
                    $e65dc6f7d1659573$var$green = "\x1B[32m";
                    $e65dc6f7d1659573$var$white = "\x1B[39m";
                    $e65dc6f7d1659573$var$red = "\x1B[31m";
                } else {
                    $e65dc6f7d1659573$var$blue = '';
                    $e65dc6f7d1659573$var$green = '';
                    $e65dc6f7d1659573$var$white = '';
                    $e65dc6f7d1659573$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($e65dc6f7d1659573$var$_typeof(actual) === 'object' && actual !== null && $e65dc6f7d1659573$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $e65dc6f7d1659573$var$copyError(actual);
                expected = $e65dc6f7d1659573$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $e65dc6f7d1659573$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $e65dc6f7d1659573$var$kReadableOperator[operator];
                var res = $e65dc6f7d1659573$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $e65dc6f7d1659573$var$_typeof(actual) === 'object' && actual !== null) base = $e65dc6f7d1659573$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($e65dc6f7d1659573$var$blue, "...").concat($e65dc6f7d1659573$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $e65dc6f7d1659573$var$inspectValue(actual);
                var other = '';
                var knownOperators = $e65dc6f7d1659573$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($e65dc6f7d1659573$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($e65dc6f7d1659573$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($e65dc6f7d1659573$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($e65dc6f7d1659573$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $e65dc6f7d1659573$var$_possibleConstructorReturn(_this);
    }
    $e65dc6f7d1659573$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $e65dc6f7d1659573$var$inspect(this, $e65dc6f7d1659573$var$_objectSpread($e65dc6f7d1659573$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $e65dc6f7d1659573$var$_wrapNativeSuper(Error), $e65dc6f7d1659573$var$inspect.custom);
module.exports = $e65dc6f7d1659573$var$AssertionError;

});

parcelRegister("75Lx4", function(module, exports) {
'use strict';

var $6T8My = parcelRequire("6T8My");
var $529ddef54709cbfd$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $529ddef54709cbfd$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $6T8My;
    if ($529ddef54709cbfd$var$lacksProperEnumerationOrder()) return $6T8My;
    if ($529ddef54709cbfd$var$assignHasPendingExceptions()) return $6T8My;
    return Object.assign;
};

});
parcelRegister("6T8My", function(module, exports) {
'use strict';

var $d0wJO = parcelRequire("d0wJO");

var $503eb11574542b41$var$hasSymbols = (parcelRequire("gAwoP"))();

var $h7gx1 = parcelRequire("h7gx1");

var $1tCdg = parcelRequire("1tCdg");
var $503eb11574542b41$var$$push = $h7gx1('Array.prototype.push');
var $503eb11574542b41$var$$propIsEnumerable = $h7gx1('Object.prototype.propertyIsEnumerable');
var $503eb11574542b41$var$originalGetSymbols = $503eb11574542b41$var$hasSymbols ? $1tCdg.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $1tCdg(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $1tCdg(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $d0wJO(from);
        var getSymbols = $503eb11574542b41$var$hasSymbols && ($1tCdg.getOwnPropertySymbols || $503eb11574542b41$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($503eb11574542b41$var$$propIsEnumerable(from, key)) $503eb11574542b41$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($503eb11574542b41$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("d0wJO", function(module, exports) {
'use strict';
var $9784ab88f76da714$var$slice = Array.prototype.slice;

var $2N9HX = parcelRequire("2N9HX");
var $9784ab88f76da714$var$origKeys = Object.keys;

var $9784ab88f76da714$var$keysShim = $9784ab88f76da714$var$origKeys ? function keys(o) {
    return $9784ab88f76da714$var$origKeys(o);
} : (parcelRequire("fTqmk"));
var $9784ab88f76da714$var$originalKeys = Object.keys;
$9784ab88f76da714$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($2N9HX(object)) return $9784ab88f76da714$var$originalKeys($9784ab88f76da714$var$slice.call(object));
            return $9784ab88f76da714$var$originalKeys(object);
        };
    } else Object.keys = $9784ab88f76da714$var$keysShim;
    return Object.keys || $9784ab88f76da714$var$keysShim;
};
module.exports = $9784ab88f76da714$var$keysShim;

});
parcelRegister("2N9HX", function(module, exports) {
'use strict';
var $2087b027f2e9d181$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $2087b027f2e9d181$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $2087b027f2e9d181$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("fTqmk", function(module, exports) {
'use strict';
var $b9207074472ec466$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $b9207074472ec466$var$has = Object.prototype.hasOwnProperty;
    var $b9207074472ec466$var$toStr = Object.prototype.toString;
    var $b9207074472ec466$var$isArgs = (parcelRequire("2N9HX")); // eslint-disable-line global-require
    var $b9207074472ec466$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $b9207074472ec466$var$hasDontEnumBug = !$b9207074472ec466$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $b9207074472ec466$var$hasProtoEnumBug = $b9207074472ec466$var$isEnumerable.call(function() {}, 'prototype');
    var $b9207074472ec466$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $b9207074472ec466$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $b9207074472ec466$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $b9207074472ec466$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$b9207074472ec466$var$excludedKeys['$' + k] && $b9207074472ec466$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $b9207074472ec466$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $b9207074472ec466$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$b9207074472ec466$var$hasAutomationEqualityBug) return $b9207074472ec466$var$equalsConstructorPrototype(o);
        try {
            return $b9207074472ec466$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $b9207074472ec466$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $b9207074472ec466$var$toStr.call(object) === '[object Function]';
        var isArguments = $b9207074472ec466$var$isArgs(object);
        var isString = isObject && $b9207074472ec466$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $b9207074472ec466$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$b9207074472ec466$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $b9207074472ec466$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($b9207074472ec466$var$hasDontEnumBug) {
            var skipConstructor = $b9207074472ec466$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $b9207074472ec466$var$dontEnums.length; ++k)if (!(skipConstructor && $b9207074472ec466$var$dontEnums[k] === 'constructor') && $b9207074472ec466$var$has.call(object, $b9207074472ec466$var$dontEnums[k])) theKeys.push($b9207074472ec466$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $b9207074472ec466$var$keysShim;

});




parcelRegister("bMTt7", function(module, exports) {
'use strict';

var $8i9kE = parcelRequire("8i9kE");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $8i9kE;
};

});
parcelRegister("8i9kE", function(module, exports) {
'use strict';
var $60973e54d27648a1$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($60973e54d27648a1$var$numberIsNaN(a) && $60973e54d27648a1$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("bGpNB", function(module, exports) {
'use strict';

var $eTCGQ = parcelRequire("eTCGQ");

var $c8tpS = parcelRequire("c8tpS");
var $8817a121adcc7f40$var$$indexOf = $c8tpS($eTCGQ('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $eTCGQ(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $8817a121adcc7f40$var$$indexOf(name, '.prototype.') > -1) return $c8tpS(intrinsic);
    return intrinsic;
};

});

parcelRegister("1Pkcj", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $154a38b5b4251d5a$var$_slicedToArray(arr, i) {
    return $154a38b5b4251d5a$var$_arrayWithHoles(arr) || $154a38b5b4251d5a$var$_iterableToArrayLimit(arr, i) || $154a38b5b4251d5a$var$_unsupportedIterableToArray(arr, i) || $154a38b5b4251d5a$var$_nonIterableRest();
}
function $154a38b5b4251d5a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $154a38b5b4251d5a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $154a38b5b4251d5a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $154a38b5b4251d5a$var$_arrayLikeToArray(o, minLen);
}
function $154a38b5b4251d5a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $154a38b5b4251d5a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $154a38b5b4251d5a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $154a38b5b4251d5a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $154a38b5b4251d5a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $154a38b5b4251d5a$var$_typeof(o);
}
var $154a38b5b4251d5a$var$regexFlagsSupported = /a/g.flags !== undefined;
var $154a38b5b4251d5a$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $154a38b5b4251d5a$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $154a38b5b4251d5a$var$objectIs = Object.is ? Object.is : (parcelRequire("ciiBM"));
var $154a38b5b4251d5a$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $154a38b5b4251d5a$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("h8Wos"));
function $154a38b5b4251d5a$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $154a38b5b4251d5a$var$hasOwnProperty = $154a38b5b4251d5a$var$uncurryThis(Object.prototype.hasOwnProperty);
var $154a38b5b4251d5a$var$propertyIsEnumerable = $154a38b5b4251d5a$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $154a38b5b4251d5a$var$objectToString = $154a38b5b4251d5a$var$uncurryThis(Object.prototype.toString);

var $1TaSd = parcelRequire("1TaSd");
var $154a38b5b4251d5a$require$_require$types = $1TaSd.types;
var $154a38b5b4251d5a$var$isAnyArrayBuffer = $154a38b5b4251d5a$require$_require$types.isAnyArrayBuffer, $154a38b5b4251d5a$var$isArrayBufferView = $154a38b5b4251d5a$require$_require$types.isArrayBufferView, $154a38b5b4251d5a$var$isDate = $154a38b5b4251d5a$require$_require$types.isDate, $154a38b5b4251d5a$var$isMap = $154a38b5b4251d5a$require$_require$types.isMap, $154a38b5b4251d5a$var$isRegExp = $154a38b5b4251d5a$require$_require$types.isRegExp, $154a38b5b4251d5a$var$isSet = $154a38b5b4251d5a$require$_require$types.isSet, $154a38b5b4251d5a$var$isNativeError = $154a38b5b4251d5a$require$_require$types.isNativeError, $154a38b5b4251d5a$var$isBoxedPrimitive = $154a38b5b4251d5a$require$_require$types.isBoxedPrimitive, $154a38b5b4251d5a$var$isNumberObject = $154a38b5b4251d5a$require$_require$types.isNumberObject, $154a38b5b4251d5a$var$isStringObject = $154a38b5b4251d5a$require$_require$types.isStringObject, $154a38b5b4251d5a$var$isBooleanObject = $154a38b5b4251d5a$require$_require$types.isBooleanObject, $154a38b5b4251d5a$var$isBigIntObject = $154a38b5b4251d5a$require$_require$types.isBigIntObject, $154a38b5b4251d5a$var$isSymbolObject = $154a38b5b4251d5a$require$_require$types.isSymbolObject, $154a38b5b4251d5a$var$isFloat32Array = $154a38b5b4251d5a$require$_require$types.isFloat32Array, $154a38b5b4251d5a$var$isFloat64Array = $154a38b5b4251d5a$require$_require$types.isFloat64Array;
function $154a38b5b4251d5a$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $154a38b5b4251d5a$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($154a38b5b4251d5a$var$isNonIndex).concat($154a38b5b4251d5a$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $154a38b5b4251d5a$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $154a38b5b4251d5a$var$ONLY_ENUMERABLE = undefined;
var $154a38b5b4251d5a$var$kStrict = true;
var $154a38b5b4251d5a$var$kLoose = false;
var $154a38b5b4251d5a$var$kNoIterator = 0;
var $154a38b5b4251d5a$var$kIsArray = 1;
var $154a38b5b4251d5a$var$kIsSet = 2;
var $154a38b5b4251d5a$var$kIsMap = 3;
// Check if they have the same source and flags
function $154a38b5b4251d5a$var$areSimilarRegExps(a, b) {
    return $154a38b5b4251d5a$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $154a38b5b4251d5a$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $154a38b5b4251d5a$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $154a38b5b4251d5a$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $154a38b5b4251d5a$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $154a38b5b4251d5a$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $154a38b5b4251d5a$var$isEqualBoxedPrimitive(val1, val2) {
    if ($154a38b5b4251d5a$var$isNumberObject(val1)) return $154a38b5b4251d5a$var$isNumberObject(val2) && $154a38b5b4251d5a$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($154a38b5b4251d5a$var$isStringObject(val1)) return $154a38b5b4251d5a$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($154a38b5b4251d5a$var$isBooleanObject(val1)) return $154a38b5b4251d5a$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($154a38b5b4251d5a$var$isBigIntObject(val1)) return $154a38b5b4251d5a$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $154a38b5b4251d5a$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $154a38b5b4251d5a$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $154a38b5b4251d5a$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($154a38b5b4251d5a$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $154a38b5b4251d5a$var$numberIsNaN(val1) && $154a38b5b4251d5a$var$numberIsNaN(val2);
        if ($154a38b5b4251d5a$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $154a38b5b4251d5a$var$_typeof(val1) !== 'object') {
            if (val2 === null || $154a38b5b4251d5a$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $154a38b5b4251d5a$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $154a38b5b4251d5a$var$objectToString(val1);
    var val2Tag = $154a38b5b4251d5a$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $154a38b5b4251d5a$var$getOwnNonIndexProperties(val1, $154a38b5b4251d5a$var$ONLY_ENUMERABLE);
        var keys2 = $154a38b5b4251d5a$var$getOwnNonIndexProperties(val2, $154a38b5b4251d5a$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $154a38b5b4251d5a$var$keyCheck(val1, val2, strict, memos, $154a38b5b4251d5a$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$154a38b5b4251d5a$var$isMap(val1) && $154a38b5b4251d5a$var$isMap(val2) || !$154a38b5b4251d5a$var$isSet(val1) && $154a38b5b4251d5a$var$isSet(val2)) return false;
    }
    if ($154a38b5b4251d5a$var$isDate(val1)) {
        if (!$154a38b5b4251d5a$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($154a38b5b4251d5a$var$isRegExp(val1)) {
        if (!$154a38b5b4251d5a$var$isRegExp(val2) || !$154a38b5b4251d5a$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($154a38b5b4251d5a$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($154a38b5b4251d5a$var$isArrayBufferView(val1)) {
        if (!strict && ($154a38b5b4251d5a$var$isFloat32Array(val1) || $154a38b5b4251d5a$var$isFloat64Array(val1))) {
            if (!$154a38b5b4251d5a$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$154a38b5b4251d5a$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $154a38b5b4251d5a$var$getOwnNonIndexProperties(val1, $154a38b5b4251d5a$var$ONLY_ENUMERABLE);
        var _keys2 = $154a38b5b4251d5a$var$getOwnNonIndexProperties(val2, $154a38b5b4251d5a$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $154a38b5b4251d5a$var$keyCheck(val1, val2, strict, memos, $154a38b5b4251d5a$var$kNoIterator, _keys);
    } else if ($154a38b5b4251d5a$var$isSet(val1)) {
        if (!$154a38b5b4251d5a$var$isSet(val2) || val1.size !== val2.size) return false;
        return $154a38b5b4251d5a$var$keyCheck(val1, val2, strict, memos, $154a38b5b4251d5a$var$kIsSet);
    } else if ($154a38b5b4251d5a$var$isMap(val1)) {
        if (!$154a38b5b4251d5a$var$isMap(val2) || val1.size !== val2.size) return false;
        return $154a38b5b4251d5a$var$keyCheck(val1, val2, strict, memos, $154a38b5b4251d5a$var$kIsMap);
    } else if ($154a38b5b4251d5a$var$isAnyArrayBuffer(val1)) {
        if (!$154a38b5b4251d5a$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($154a38b5b4251d5a$var$isBoxedPrimitive(val1) && !$154a38b5b4251d5a$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $154a38b5b4251d5a$var$keyCheck(val1, val2, strict, memos, $154a38b5b4251d5a$var$kNoIterator);
}
function $154a38b5b4251d5a$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $154a38b5b4251d5a$var$propertyIsEnumerable(val, k);
    });
}
function $154a38b5b4251d5a$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$154a38b5b4251d5a$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $154a38b5b4251d5a$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($154a38b5b4251d5a$var$propertyIsEnumerable(val1, key)) {
                    if (!$154a38b5b4251d5a$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($154a38b5b4251d5a$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $154a38b5b4251d5a$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $154a38b5b4251d5a$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $154a38b5b4251d5a$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $154a38b5b4251d5a$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $154a38b5b4251d5a$var$kNoIterator || iterationType === $154a38b5b4251d5a$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $154a38b5b4251d5a$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $154a38b5b4251d5a$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $154a38b5b4251d5a$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($154a38b5b4251d5a$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $154a38b5b4251d5a$var$findLooseMatchingPrimitives(prim) {
    switch($154a38b5b4251d5a$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($154a38b5b4251d5a$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $154a38b5b4251d5a$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $154a38b5b4251d5a$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $154a38b5b4251d5a$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $154a38b5b4251d5a$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$154a38b5b4251d5a$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $154a38b5b4251d5a$var$innerDeepEqual(item, curB, false, memo);
}
function $154a38b5b4251d5a$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $154a38b5b4251d5a$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($154a38b5b4251d5a$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$154a38b5b4251d5a$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $154a38b5b4251d5a$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($154a38b5b4251d5a$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$154a38b5b4251d5a$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$154a38b5b4251d5a$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $154a38b5b4251d5a$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $154a38b5b4251d5a$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($154a38b5b4251d5a$var$innerDeepEqual(key1, key2, strict, memo) && $154a38b5b4251d5a$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $154a38b5b4251d5a$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $154a38b5b4251d5a$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $154a38b5b4251d5a$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($154a38b5b4251d5a$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$154a38b5b4251d5a$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$154a38b5b4251d5a$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $154a38b5b4251d5a$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $154a38b5b4251d5a$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($154a38b5b4251d5a$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$154a38b5b4251d5a$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$154a38b5b4251d5a$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$154a38b5b4251d5a$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $154a38b5b4251d5a$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $154a38b5b4251d5a$var$kIsSet) {
        if (!$154a38b5b4251d5a$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $154a38b5b4251d5a$var$kIsMap) {
        if (!$154a38b5b4251d5a$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $154a38b5b4251d5a$var$kIsArray) for(; i < a.length; i++){
        if ($154a38b5b4251d5a$var$hasOwnProperty(a, i)) {
            if (!$154a38b5b4251d5a$var$hasOwnProperty(b, i) || !$154a38b5b4251d5a$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($154a38b5b4251d5a$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$154a38b5b4251d5a$var$hasOwnProperty(b, key) || !$154a38b5b4251d5a$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$154a38b5b4251d5a$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $154a38b5b4251d5a$var$isDeepEqual(val1, val2) {
    return $154a38b5b4251d5a$var$innerDeepEqual(val1, val2, $154a38b5b4251d5a$var$kLoose);
}
function $154a38b5b4251d5a$var$isDeepStrictEqual(val1, val2) {
    return $154a38b5b4251d5a$var$innerDeepEqual(val1, val2, $154a38b5b4251d5a$var$kStrict);
}
module.exports = {
    isDeepEqual: $154a38b5b4251d5a$var$isDeepEqual,
    isDeepStrictEqual: $154a38b5b4251d5a$var$isDeepStrictEqual
};

});
parcelRegister("ciiBM", function(module, exports) {
'use strict';

var $7iKTg = parcelRequire("7iKTg");

var $c8tpS = parcelRequire("c8tpS");

var $8i9kE = parcelRequire("8i9kE");

var $bMTt7 = parcelRequire("bMTt7");

var $33GTT = parcelRequire("33GTT");
var $8f3599b1c7ce4a4a$var$polyfill = $c8tpS($bMTt7(), Object);
$7iKTg($8f3599b1c7ce4a4a$var$polyfill, {
    getPolyfill: $bMTt7,
    implementation: $8i9kE,
    shim: $33GTT
});
module.exports = $8f3599b1c7ce4a4a$var$polyfill;

});
parcelRegister("7iKTg", function(module, exports) {
'use strict';

var $d0wJO = parcelRequire("d0wJO");
var $550e9645d9aa4dfd$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $550e9645d9aa4dfd$var$toStr = Object.prototype.toString;
var $550e9645d9aa4dfd$var$concat = Array.prototype.concat;

var $4Q3a0 = parcelRequire("4Q3a0");
var $550e9645d9aa4dfd$var$isFunction = function(fn) {
    return typeof fn === 'function' && $550e9645d9aa4dfd$var$toStr.call(fn) === '[object Function]';
};

var $550e9645d9aa4dfd$var$supportsDescriptors = (parcelRequire("in0nB"))();
var $550e9645d9aa4dfd$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$550e9645d9aa4dfd$var$isFunction(predicate) || !predicate()) return;
    }
    if ($550e9645d9aa4dfd$var$supportsDescriptors) $4Q3a0(object, name, value, true);
    else $4Q3a0(object, name, value);
};
var $550e9645d9aa4dfd$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $d0wJO(map);
    if ($550e9645d9aa4dfd$var$hasSymbols) props = $550e9645d9aa4dfd$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$550e9645d9aa4dfd$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$550e9645d9aa4dfd$var$defineProperties.supportsDescriptors = !!$550e9645d9aa4dfd$var$supportsDescriptors;
module.exports = $550e9645d9aa4dfd$var$defineProperties;

});

parcelRegister("33GTT", function(module, exports) {
'use strict';

var $bMTt7 = parcelRequire("bMTt7");

var $7iKTg = parcelRequire("7iKTg");
module.exports = function shimObjectIs() {
    var polyfill = $bMTt7();
    $7iKTg(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("h8Wos", function(module, exports) {
'use strict';

var $c8tpS = parcelRequire("c8tpS");

var $7iKTg = parcelRequire("7iKTg");

var $ek0P5 = parcelRequire("ek0P5");

var $iHWPb = parcelRequire("iHWPb");

var $8c0bz = parcelRequire("8c0bz");
var $c7b07abe580f715e$var$polyfill = $c8tpS($iHWPb(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $7iKTg($c7b07abe580f715e$var$polyfill, {
    getPolyfill: $iHWPb,
    implementation: $ek0P5,
    shim: $8c0bz
});
module.exports = $c7b07abe580f715e$var$polyfill;

});
parcelRegister("ek0P5", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("iHWPb", function(module, exports) {
'use strict';

var $ek0P5 = parcelRequire("ek0P5");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $ek0P5;
};

});

parcelRegister("8c0bz", function(module, exports) {
'use strict';

var $7iKTg = parcelRequire("7iKTg");

var $iHWPb = parcelRequire("iHWPb");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $iHWPb();
    $7iKTg(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




//handling cookies
const $f47fa8cc8f06f4d0$export$110700823644f4a6 = (name, value, days)=>{
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};
const $f47fa8cc8f06f4d0$export$4be65e66cfa2648a = (name)=>{
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
const $f47fa8cc8f06f4d0$export$84a9c3647d39324f = (name)=>{
    document.cookie = name + "=; Max-Age=-99999999;";
};


const $b938cbac48dc0193$export$92948c9bcc5cf1fb = "/";
const $b938cbac48dc0193$export$f13542cb62baa945 = 30; //days
const $b938cbac48dc0193$export$c28d632fe28a2226 = "page-main";
const $b938cbac48dc0193$export$6f20c54358240ac3 = 480;
const $b938cbac48dc0193$export$1c20094c5869d61e = 720;
const $b938cbac48dc0193$export$907802a71237407c = [
    {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [
            {
                color: "#ffffff"
            }
        ]
    },
    {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
            {
                color: "#000000"
            },
            {
                lightness: 13
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#000000"
            }
        ]
    },
    {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#144b53"
            },
            {
                lightness: 14
            },
            {
                weight: 1.4
            }
        ]
    },
    {
        featureType: "landscape",
        elementType: "all",
        stylers: [
            {
                color: "#08304b"
            }
        ]
    },
    {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
            {
                color: "#0c4152"
            },
            {
                lightness: 5
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#000000"
            }
        ]
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#0b434f"
            },
            {
                lightness: 25
            }
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
            {
                color: "#000000"
            }
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
            {
                color: "#0b3d51"
            },
            {
                lightness: 16
            }
        ]
    },
    {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
            {
                color: "#000000"
            }
        ]
    },
    {
        featureType: "transit",
        elementType: "all",
        stylers: [
            {
                color: "#146474"
            }
        ]
    },
    {
        featureType: "water",
        elementType: "all",
        stylers: [
            {
                color: "#021019"
            }
        ]
    }
];


const $d465b9e7e2f0fb62$export$5875d69cb83cae16 = (id)=>{
    return $d465b9e7e2f0fb62$export$69ca9a73988774ff(id, "_", "/");
};
const $d465b9e7e2f0fb62$export$71e8fe009c6edccb = (url)=>{
    return $d465b9e7e2f0fb62$export$69ca9a73988774ff(url, "/", "_");
};
const $d465b9e7e2f0fb62$export$35f65831a1b86006 = ()=>{
    if ((0, $b938cbac48dc0193$export$92948c9bcc5cf1fb) === "#") return window.location.hash.substr(1);
    if ((0, $b938cbac48dc0193$export$92948c9bcc5cf1fb) === "/") return $d465b9e7e2f0fb62$export$71e8fe009c6edccb(window.location.pathname.slice(1));
};
const $d465b9e7e2f0fb62$export$69ca9a73988774ff = (string, remove, add)=>{
    return string.split(remove).join(add);
};
const $d465b9e7e2f0fb62$export$950b37d457a427ef = (url)=>{
    try {
        history.pushState(null, null, (0, $b938cbac48dc0193$export$92948c9bcc5cf1fb) + url);
    } catch (e) {
        console.log("history not available");
    }
};
const $d465b9e7e2f0fb62$export$f8908bc8876e1434 = ($element)=>$element.get(0).scrollHeight > $element.outerHeight();
const $d465b9e7e2f0fb62$export$293e19f0ac43283a = (id)=>$(`[data-info-popup="#${$d465b9e7e2f0fb62$export$5875d69cb83cae16(id)}"]`).first();
const $d465b9e7e2f0fb62$export$5581d7648cc92bef = (id)=>$(`.page-content:has(a[href="${id}"])`);
const $d465b9e7e2f0fb62$export$e758ae0a3ed6423a = ()=>{
    if ($d465b9e7e2f0fb62$export$5cd843239dff6e53()) return window.innerHeight <= (0, $b938cbac48dc0193$export$6f20c54358240ac3);
    else return window.innerWidth <= (0, $b938cbac48dc0193$export$6f20c54358240ac3);
};
const $d465b9e7e2f0fb62$export$cbc7c17b7602658a = ()=>window.innerWidth <= (0, $b938cbac48dc0193$export$1c20094c5869d61e);
const $d465b9e7e2f0fb62$export$5cd843239dff6e53 = ()=>window.orientation === 90 || window.orientation === -90;
const $d465b9e7e2f0fb62$export$61fc7d43ac8f84b0 = (func, wait, immediate)=>{
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
const $d465b9e7e2f0fb62$export$b49e015b14cad516 = ($video)=>{
    const player = $video.get(0).plyr;
    player.play();
};
const $d465b9e7e2f0fb62$export$2bb74740c4e19def = (el)=>{
    if (!el) return null;
    return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
};
const $d465b9e7e2f0fb62$export$a54024773f4db157 = (el, threshold = 1)=>{
    if (!el) return false;
    return el.scrollHeight - el.scrollTop - el.clientHeight <= threshold;
};
const $d465b9e7e2f0fb62$export$87ea26e4f2c3dc7d = (el, threshold = 1)=>{
    if (!el) return false;
    return el.scrollTop <= threshold;
};
const $d465b9e7e2f0fb62$export$3dcce53a3755dc8c = ()=>{
    const ua = navigator.userAgent;
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
    const isFirefox = /Firefox\/\d+/i.test(ua) && !/Seamonkey/i.test(ua);
    const isChrome = /Chrome\/\d+/i.test(ua) && !/Edge|Edg|OPR|Brave/i.test(ua);
    const isSafari = /Safari/i.test(ua) && !/Chrome|Chromium|Edg|OPR|Brave/i.test(ua);
    isMobile && document.documentElement.classList.add('mobile');
    isFirefox && document.documentElement.classList.add('firefox');
    isChrome && document.documentElement.classList.add('chrome');
    isSafari && document.documentElement.classList.add('safari');
};


parcelRequire("1ig8x");
const $d5f149f1c634c5f8$export$3ea0b4c0900c5786 = ($page)=>{
    if ($page.hasClass("lazyload-done")) return;
    const loadings = $page.find(".section__img.lazyload").map(async function() {
        if ($(this).hasClass("image-loaded")) return;
        await $d5f149f1c634c5f8$export$fe58198efe02b173($(this).data("src"));
        $(this).attr("src", $(this).data("src"));
        $(this).addClass("image-loaded");
    });
    return Promise.all(loadings).then(()=>{
        $page.addClass("lazyload-done");
    });
};
const $d5f149f1c634c5f8$export$fe58198efe02b173 = (src)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>resolve();
        img.onerror = ()=>reject;
        img.src = src;
    });



// Detect user agent and add classes to HTML
(0, $d465b9e7e2f0fb62$export$3dcce53a3755dc8c)();
$(document).ready(function() {
    const $body = $("body");
    let $lastPlayedVideo;
    /* swipe */ $(".page-content, .popup-window--size-video").swipe({
        //Generic swipe handler for all directions
        swipe: function(event1, direction) {
            if (direction === "up") goToNextSection();
            else if (direction === "down") goToPreviousSection();
        },
        excludedElements: "button, input, select, progress, textarea, a, .noSwipe" // , .popup-window__content
    });
    /* set .page-content height with js to screen height - makes problems in safari when set with css */ // const $pageContent = $('.page-content');
    // $pageContent.css('height', window.innerHeight || $(window).height());
    // $(window).on('resize', function() {
    //   $pageContent.css('height', window.innerHeight || $(window).height());
    // });
    /* popup window */ const $coverScreen = $("#cover-screen");
    const $popupWindows = $(".popup-window");
    $popupWindows.each(function() {
        //bind to video 'ended' envet
        const $popup = $(this);
        if (!$popup.hasClass("popup-window--size-video")) return;
        const $video = $popup.find(".plyr-player__video");
        $video.on("ended", (event1)=>{
            //move to next section when video ends
            closePopups();
            goToNextSection();
        });
    });
    $(".popup-trigger").on("click", function(e) {
        e.preventDefault();
        const id = $(this).attr("href");
        openPopup($(id));
    });
    $coverScreen.on("click", ()=>{
        if ($(".popup-window--no-close.active").length === 1) return;
        closePopups(true);
    });
    $(".popup-window__close").on("click", (event1)=>{
        closePopups(true);
    });
    $(".popup-window--size-video").on("click", ()=>{
        const $target = $(event.target);
        //close video popup when clicked inside the popup but outside the video
        if ($target.hasClass(".plyr-player") || $target.closest(".plyr-player").length) return;
        closePopups(true);
    });
    function openPopup($popup) {
        $coverScreen.addClass("active");
        if ($popup.hasClass("popup-window--x-zdepth")) $coverScreen.addClass("cover-screen--x-zdepth");
        // $popup.css("top", $(window).scrollTop() + $(window).height() / 2);
        $popup.addClass("active");
        if ($popup.hasClass("popup-window--no-close")) $coverScreen.addClass("cover-screen--above");
        if ($popup.hasClass("popup-window--cover-dark")) $coverScreen.addClass("cover-screen--dark");
        if ($popup.hasClass("popup-window--cover-light")) $coverScreen.addClass("cover-screen--light");
        if ($popup.hasClass("popup-window--size-video")) {
            //plyr video player
            const $video = $popup.find(".plyr-player__video");
            if (!$popup.hasClass("popup-window--video-initialized")) {
                if ((0, $d465b9e7e2f0fb62$export$cbc7c17b7602658a)() && $video.data("sm-src")) {
                    $video.find("source").attr("src", $video.data("sm-src"));
                    $video.get(0).load(); //make the video to reload because of the src attribute change
                }
                const player = new Plyr($popup.find(".plyr-player__video").get(0), {
                    iconUrl: "/wp-content/themes/mim/plyr/plyr.svg" //"./plyr/plyr.svg"
                });
                $video.on("ready", function() {
                    $popup.find('.plyr__control--overlaid svg').replaceWith('<img src="/wp-content/themes/mim/images/play.svg" class="plyr-custom-play" />');
                    var where = $(this);
                    $(window).keypress(function(ekey) {
                        if (ekey.which === 32) {
                            console.log('pressed');
                            ekey.preventDefault();
                            if ($(where).closest('.popup-window').hasClass('active')) {
                                var plr_el = $(where).get(0).plyr;
                                //if (!plr_el.fullscreen.active) {
                                plr_el.togglePlay();
                            //}
                            }
                        }
                    });
                });
                $popup.addClass("popup-window--video-initialized");
            }
            setPopupVideoHeight($popup, $video);
            (0, $d465b9e7e2f0fb62$export$b49e015b14cad516)($video);
            $lastPlayedVideo = $video;
        }
    }
    function setPopupVideoHeight($popup, $video) {
        const $root = $video.closest(".plyr-player");
        $video.css("height", "auto");
        $root.removeClass("plyr-player--inline");
        if ($popup.height() < $video.height()) {
            $video.css("height", $popup.height() + "px");
            $root.addClass("plyr-player--inline");
        }
    }
    function closePopups(resetLastPlayedVideo = false) {
        $popupWindows.each(function() {
            //stop popup video
            if (!$(this).hasClass("active") || !$(this).hasClass("popup-window--size-video")) return;
            const plyr = $(this).find(".plyr-player__video").get(0).plyr;
            plyr.fullscreen.exit();
            //in case native players exit fullscreen not with plyr
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
            //when fullscreen plyr.pause() doesn't seem to be reliable, setTimeout fixes it
            setTimeout(()=>{
                plyr.pause();
            }, 0);
        });
        if (resetLastPlayedVideo) $lastPlayedVideo = null;
        $popupWindows.removeClass("active");
        $coverScreen.removeClass("active cover-screen--above cover-screen--dark cover-screen--light cover-screen--x-zdepth");
    }
    // $(window).on("resize", () => {
    //   const $activePopup = $(".popup-window.active");
    //   if ($activePopup.length)
    //     $activePopup.css("top", $(window).scrollTop() + $(window).height() / 2);
    // });
    //menu open/close
    const $navMain = $("#nav-main");
    $(".nav-menu-btn").on("click", ()=>{
        closePopups();
        closeSideSlides();
        $navMain.addClass("active");
    // navMainFitFont();
    });
    $(".nav-main-close").on("click", ()=>{
        $navMain.removeClass("active");
    });
    //submenu toggle
    (function() {
        const links = [
            ...document.querySelectorAll('#nav-main-content > ul > li > a')
        ];
        const openClass = 'open';
        links.forEach((link)=>link.addEventListener('click', (e)=>{
                const submenu = link.nextElementSibling;
                // const isAccordion = getComputedStyle(submenu).overflow === 'hidden';
                if (!submenu) return;
                e.preventDefault();
                const item = link.closest('li');
                const openItem = links.find((link)=>link.closest('li').classList.contains(openClass))?.closest('li');
                openItem?.classList.remove(openClass);
                if (item !== openItem) item.classList.add(openClass);
            }));
    })();
    function closeSideSlides() {
        $(".side-slide").removeClass("active");
    }
    //menu fit font to screen size
    // const $navMainContent = $("#nav-main-content");
    // function navMainFitFont() {
    //   $navMainContent.textfill({
    //     maxFontPixels: 100,
    //     innerTag: "ul"
    //   });
    // }
    /* in page navigation */ const $navInfoButton = $("#nav-info-btn");
    $navInfoButton.on("click", ()=>{
        closePopups(); //nav links are above screen cover so there might be some popup opened
        const $target = $((0, $d465b9e7e2f0fb62$export$71e8fe009c6edccb)($(".page-content.active").data("info-popup")));
        if ($target.hasClass("popup-window")) openPopup($target);
        else if ($target.hasClass("side-slide")) $target.addClass("active");
        if ($target.hasClass("add-to-history")) (0, $d465b9e7e2f0fb62$export$950b37d457a427ef)((0, $d465b9e7e2f0fb62$export$5875d69cb83cae16)($target.attr("id")));
    });
    //show contact map
    $(".nav-contact-btn").on("click", ()=>{
        $("#content-map").addClass("active");
    });
    let $navFilms;
    $("#nav-films-btn").on("click", ()=>{
        if (!$navFilms) $navFilms = $("#nav-films");
        $navFilms.toggleClass("active");
    });
    let $navDirectors;
    $("#nav-directors-btn").on("click", ()=>{
        if (!$navDirectors) $navDirectors = $("#nav-directors");
        $navDirectors.toggleClass("active");
    });
    $(".nav-trigger-next").on("click", ()=>{
        closePopups(true); //nav links are above screen cover so there might be some popup opened
        goToNextSection();
    });
    $(".nav-trigger-open-intro").on("click", (e)=>{
        closePopups(true); //nav links are above screen cover so there might be some popup opened
        const openClass = 'intro-open';
        if (document.body.classList.contains(openClass)) goToNextSection();
        else {
            document.body.classList.add(openClass);
            // Safari "bug": font stays italic
            const btn = e.currentTarget;
            btn.style.fontStyle = 'normal';
        // btn.closest('.container').addEventListener('transitionend', (e) => {
        //   if (e.propertyName !== 'translate') return;
        //   btn.removeAttribute('style');
        // }, { once: true });
        }
    });
    //go to next section on mousewheel / touchmove
    let touchStartY = 0;
    document.addEventListener("touchstart", (e)=>{
        touchStartY = e.touches[0].clientY;
    }, {
        passive: true
    });
    const handleDocumentScroll = (e)=>{
        const isTouch = e.type === "touchmove";
        const direction = (()=>{
            if (isTouch) {
                const delta = touchStartY - e.touches[0].clientY;
                return delta > 0 ? 'down' : 'up';
            } else return e.deltaY > 0 ? 'down' : 'up';
        })();
        const deltaY = isTouch ? touchStartY - e.touches[0].clientY : e.deltaY;
        const $target = $(e.target);
        const $container = $target.closest(".popup-window, .side-slide");
        const popupContent = $container[0]?.querySelector('.popup-window__content');
        if ($container.length && ($container.hasClass("side-slide") || $container.hasClass("disable-section-scroll"))) return; // Let user scroll the popup
        if (Math.abs(deltaY) > 10) {
            e.preventDefault(); // Block section scroll when not needed
            if (direction === 'down') goToNextSection();
            else goToPreviousSection();
        }
    };
    // const handleDocumentScrollDebounced = debounce(
    //   handleDocumentScroll,
    //   100,
    //   true
    // );
    // $(document).on("wheel", handleDocumentScroll);
    document.addEventListener("wheel", handleDocumentScroll, {
        passive: false
    });
    // document.addEventListener("touchmove", handleDocumentScroll, { passive: false });
    const $sideSlides = $(".side-slide");
    $(".nav-trigger").on("click", function(e) {
        closePopups(); //nav links are above screen cover so there might be some popup opened
        e.preventDefault();
        $sideSlides.removeClass("active"); //hide side menus
        const targetID = (0, $d465b9e7e2f0fb62$export$71e8fe009c6edccb)($(this).attr("href"));
        const $target = $(targetID);
        if ($target.hasClass("page-content")) {
            swapPages($target, $(this).data("source-category"));
            // autoplay video if user comes from .card-grid (nav with preview cards)
            if (e.currentTarget.closest('.card-grid') || e.currentTarget.classList.contains('click-autoplay')) $target.find('.popup-trigger').click();
        } else if ($target.hasClass("side-slide")) {
            $target.addClass("active");
            if ($target.hasClass("add-to-history")) (0, $d465b9e7e2f0fb62$export$950b37d457a427ef)((0, $d465b9e7e2f0fb62$export$5875d69cb83cae16)($target.attr("id")));
        } else $target.addClass("active");
        // page with featured image - push side controls down
        if ($target.find('.content-info__featured-image').length > 0) $target[0].addEventListener('transitionend', (e)=>{
            if (e.propertyName !== 'transform') return;
            $target[0].style.setProperty('--side-btn-offset', `0px`); // reset before getting top offset
            const contentTop = $('.content-info__content-header', $target)[0].getBoundingClientRect().top;
            const $closeBtns = $('.side-slide__close', $target);
            const closeTop = $closeBtns[0].getBoundingClientRect().top;
            $target[0].style.setProperty('--side-btn-offset', `${contentTop - closeTop - 20}px`); // 20 ~ letter spacing
        }, {
            once: true
        });
    });
    $(".side-slide__close").on("click", function() {
        const $target = $(this).closest(".side-slide");
        $target.removeClass("active");
        if ($target.hasClass("add-to-history")) (0, $d465b9e7e2f0fb62$export$950b37d457a427ef)((0, $d465b9e7e2f0fb62$export$5875d69cb83cae16)($(".page-content.active").attr("id")));
        if ($(this).hasClass("side-slide__close--resume-video") && $lastPlayedVideo && $lastPlayedVideo.length) {
            openPopup($lastPlayedVideo.closest(".popup-window"));
            (0, $d465b9e7e2f0fb62$export$b49e015b14cad516)($lastPlayedVideo);
        }
        if ($target.is('#nav-main')) $target.find('.nav-list__item.open').removeClass('open');
    });
    function goToPreviousSection() {
        if (!isUIAccessible()) return;
        const $pageActive = $(".page-content.active").last(); //if swapPages is in progress, there will be two elements with this selector
        const $pagePrev = getPrevPage($pageActive);
        if ($pagePrev.length === 0) return;
        swapPages($pagePrev, null, "top");
        playPauseVideo($pageActive, $pagePrev);
    }
    function goToNextSection() {
        if (!isUIAccessible()) return;
        const $pageActive = $(".page-content.active").first(); //if swapPages is in progress, there will be two elements with this selector
        let $pageNext = getNextPage($pageActive);
        if ($pageNext.length === 0) $pageNext = getFirstPageFromCategory(getPageMainCategory($pageActive));
        if ($pageNext.length === 0) return;
        swapPages($pageNext, $pageActive.data("source-category"));
        playPauseVideo($pageActive, $pageNext);
        // update 'next' button text
        const $nextBtn = $('#nav-next-btn');
        $nextBtn.text($nextBtn.data('text'));
    }
    function playPauseVideo($pageActive, $pageNext) {
        if ($pageActive) {
            const activeVideo = $pageActive[0].querySelector('.section__video');
            if (activeVideo) activeVideo.pause();
        }
        if ($pageNext) {
            const nextVideo = $pageNext[0].querySelector('.section__video');
            if (nextVideo) nextVideo.play();
        }
    }
    function isUIAccessible() {
        return isCorrectScreen();
    }
    function getFirstPageFromCategory(category) {
        let $page = $();
        $(".page-content").each(function() {
            const pageCategories = $(this).data("category");
            if (!pageCategories) return;
            if (pageCategories.split(",").includes(category)) {
                $page = $(this);
                return false; //page found, stop the each loop
            }
        });
        return $page;
    }
    function getNextPage($page) {
        const pageCategory = getPageMainCategory($page);
        let $pageNext = $page.next(".page-content");
        while($pageNext.length === 1){
            //loop next pages and find the first with current category
            const pageNextCategories = $pageNext.data("category");
            if (!pageNextCategories) continue;
            if (pageNextCategories.split(",").includes(pageCategory)) break;
            $pageNext = $pageNext.next(".page-content");
        }
        return $pageNext;
    }
    function getPrevPage($page) {
        const pageCategory = getPageMainCategory($page);
        let $pagePrev = $page.prev(".page-content");
        while($pagePrev.length === 1){
            //loop previous pages and find the first with current category
            const pagePrevCategories = $pagePrev.data("category");
            if (!pagePrevCategories) continue;
            if (pagePrevCategories.split(",").includes(pageCategory)) break;
            $pagePrev = $pagePrev.prev(".page-content");
        }
        return $pagePrev;
    }
    function getPageMainCategory($page) {
        if ($page.data("source-category")) return $page.data("source-category");
        if ($page.data("category")) return $page.data("category").split(",")[0];
    }
    const $navNextBtn = $("#nav-next-btn");
    function swapPages($pageNext, sourceCategory, directory = "bottom", addToHistory = true) {
        $('.mim-pain--hide-before-dom-ready', $pageNext).removeAttr('style');
        if ($pageNext.hasClass("active")) {
            //set source category for the currect page, because that could have changed
            sourceCategory && $pageNext.data("source-category", sourceCategory);
            activatePageCategoryButton($pageNext); //show/hide category button
            //do not swap page with itself
            //also prevents other swaps until the previous is done
            return;
        }
        //reset last played video, bacause it would be on another page
        $lastPlayedVideo = null;
        //set source category for the next page
        sourceCategory && $pageNext.data("source-category", sourceCategory);
        //swap pages
        const $pageActive = $(".page-content.active");
        //set transition for the pages to swap from top or bottom
        $pageActive.addClass("no-transition");
        $pageNext.addClass("no-transition");
        if (directory === "top") {
            $pageActive.addClass("anim-reverse");
            $pageNext.addClass("anim-reverse");
        } else if (directory === "bottom") {
            $pageActive.removeClass("anim-reverse");
            $pageNext.removeClass("anim-reverse");
        }
        $pageActive.get(0).offsetWidth; //rerender the element to reset css transition
        $pageNext.get(0).offsetWidth;
        $pageActive.removeClass("no-transition");
        $pageNext.removeClass("no-transition");
        $pageActive.addClass("unactive");
        $pageNext.addClass("active");
        //elements inside the page trigger transitionend event because it's propagated, so it's important
        //to check the event target and then remove event listener
        const transitionEndHandler = (e)=>{
            if (!$(e.target).hasClass("page-content")) return;
            $pageNext.off("transitionend", transitionEndHandler);
            $pageActive.addClass("no-transition");
            $pageActive.removeClass("active unactive");
            $pageActive.get(0).offsetWidth;
            $pageActive.removeClass("no-transition");
        };
        $pageNext.on("transitionend", transitionEndHandler);
        closePopups(true);
        if (addToHistory) (0, $d465b9e7e2f0fb62$export$950b37d457a427ef)((0, $d465b9e7e2f0fb62$export$5875d69cb83cae16)($pageNext.attr("id")));
        setupPage($pageNext);
    }
    function setupPage($page) {
        //lazyload for page's big image
        (0, $d5f149f1c634c5f8$export$3ea0b4c0900c5786)($page);
        activatePageCategoryButton($page); //show/hide category button
        activatePageInfoButton($page); //show/hide info button
        //show/hide navigation buttons
        if ($page.hasClass("page-content--nav-hidden")) $body.addClass("nav-hidden");
        else $body.removeClass("nav-hidden");
        //show/hide navigation "next" button
        const hasNextPage = pageHasNextPage($page);
        hasNextPage ? $navNextBtn.removeClass("unactive") : $navNextBtn.addClass("unactive");
    }
    function pageHasNextPage($page, continueFromTop = true) {
        let $nextPage = getNextPage($page);
        if ($nextPage.length === 0 && continueFromTop) $nextPage = getFirstPageFromCategory(getPageMainCategory($page));
        return $nextPage.length === 1 && !$nextPage.is($page);
    }
    let $categoryBtns;
    function activatePageCategoryButton($page) {
        //display corresponding category button, hide others
        let category = $page.data("source-category") || $page.data("category-button");
        if (!category && $page.data("category")) category = $page.data("category").split(",")[0];
        if (!$categoryBtns) $categoryBtns = $(".nav-side-btn--category");
        $categoryBtns.removeClass("active");
        if (category) {
            const $categoryBtn = $(`#nav-${category}-btn`);
            $categoryBtn.length && $categoryBtn.addClass("active");
        }
    }
    function activatePageInfoButton($page) {
        if ($page.data("info-popup")) $body.removeClass("nav-info-hidden");
        else $body.addClass("nav-info-hidden");
    }
    //switch slide handling
    $(".switch-slide").each(function() {
        const $root = $(this);
        $root.find(".switch-slide__def").on("click", ()=>{
            $root.addClass("active");
        });
        $root.find(".switch-slide__hover").on("click", ()=>{
            $root.removeClass("active");
        });
    });
    $(document).on("click", function(e) {
        //close when clicked outside
        const $switchSlide = $(e.target).closest(".switch-slide");
        if ($switchSlide.length) $switchSlide.removeClass("active");
    });
    //navigate on key press
    $(document).on("keydown", (e)=>{
        if (e.keyCode === 38) //up
        goToPreviousSection();
        else if (e.keyCode === 40) //down
        goToNextSection();
    /*
      else if(e.keyCode === 37) //left
      else if(e.keyCode === 39) //right
      */ });
    //show/hide share icons
    $(".side-slide__share").on("mouseenter", function() {
        $(this).closest(".content-info").find(".content-share").addClass("active");
    }).on("mouseleave", function() {
        $(this).closest(".content-info").find(".content-share").removeClass("active");
    });
    //set initial page based on url hash
    const urlTargetAnchor = (0, $d465b9e7e2f0fb62$export$35f65831a1b86006)();
    setStartingPage(urlTargetAnchor);
    if (!$(".page-content.active").hasClass("page-content--nav-hidden")) $body.removeClass("nav-hidden");
    $body.addClass("initial-page-set");
    function setStartingPage(targetAnchor) {
        let $startingPage;
        if (!targetAnchor || targetAnchor === (0, $b938cbac48dc0193$export$c28d632fe28a2226)) return; //no need to load the default page
        const $startingTarget = $(`#${targetAnchor}`);
        if (!$startingTarget.length) return; //404 screen could be displayed here, or just let it fall back to the default page
        if ($startingTarget.hasClass("page-content")) initStartingPage($startingTarget);
        else if ($startingTarget.hasClass("content-info")) {
            //target is popup, so first get page having that popup (if any), activate that page and activate the popup
            $startingPage = (0, $d465b9e7e2f0fb62$export$293e19f0ac43283a)($startingTarget.attr("id"));
            if (!$startingPage.length) $startingPage = $(`#${(0, $b938cbac48dc0193$export$c28d632fe28a2226)}`);
            initStartingPage($startingPage);
            $startingTarget.addClass("active");
        }
        //unrecognized page type, 404 screen could be displayed here, or just let it fall back to the default page
        playPauseVideo(null, $startingTarget);
        // page with featured image - push side controls down
        if ($startingTarget.find('.content-info__featured-image').length > 0) {
            $startingTarget[0].style.setProperty('--side-btn-offset', `0px`); // reset before getting top offset
            const contentTop = $('.content-info__content-header', $startingTarget)[0].getBoundingClientRect().top;
            const $closeBtns = $('.side-slide__close', $startingTarget);
            const closeTop = $closeBtns[0].getBoundingClientRect().top;
            $startingTarget[0].style.setProperty('--side-btn-offset', `${contentTop - closeTop - 20}px`); // 20 ~ letter spacing
        }
    }
    async function initStartingPage($page) {
        $('.mim-pain--hide-before-dom-ready', $page).removeAttr('style');
        $(`#${(0, $b938cbac48dc0193$export$c28d632fe28a2226)}`).removeClass("active");
        $page.addClass("active");
        await (0, $d5f149f1c634c5f8$export$3ea0b4c0900c5786)($page);
        activatePageCategoryButton($page);
        activatePageInfoButton($page);
    }
    //window orientation has to be landscape on small devices
    // const isCorrectScreen = () => !isMobileScreen() || isLandscape();
    const isCorrectScreen = ()=>true;
    // if (!isCorrectScreen()) {
    //   openPopup($("#landscape-required-popup"));
    // }
    // $(window).on("orientationchange", function() {
    //   $(window).one("resize", function() {
    //     setTimeout(() => {
    //       if (isCorrectScreen()) {
    //         if ($("#landscape-required-popup.active").length) {
    //           closePopups(true);
    //           checkCookieConsent();
    //         }
    //       } else {
    //         closePopups(true);
    //         openPopup($("#landscape-required-popup"));
    //       }
    //     }, 0);
    //   });
    // });
    //cookie consent
    if (isCorrectScreen()) checkCookieConsent();
    function checkCookieConsent() {
        $body.addClass("cookies-confirmed");
        return true;
    }
    //madeinmunich.com is dead
    (function() {
        const url = new URL(window.location);
        const path = url.pathname.split("/").pop(); // mim-film.de/madeinmunich
        const queryString = [
            ...url.searchParams.keys()
        ][0]; // mim-film.de/?madeinmunich
        if ([
            path,
            queryString
        ].includes('madeinmunich')) openMadeInMunichPopup();
    })();
    function openMadeInMunichPopup() {
        const popup = $("#made-in-munich-popup");
        const closeBtn = $("#made-in-munich-btn");
        const showMimDead = localStorage.getItem('mim-dead') !== '1';
        if (showMimDead) openPopup(popup);
        closeBtn.on("click", ()=>{
            localStorage.setItem('mim-dead', '1');
            popup.removeClass("active");
        });
    }
    //open/close box openable
    $(".box-openable__head").on("click", function() {
        $(this).parent(".box-openable").toggleClass("active");
    });
    //load new page on history change in browser
    $(window).on("popstate", function(e) {
        if (!isCorrectScreen()) //if sreen is not correct, do not continue, that would close the "your-screen-is-not-correct" popup and make web available
        return;
        closePopups(true);
        closeSideSlides();
        let targetID = (0, $d465b9e7e2f0fb62$export$35f65831a1b86006)();
        if (!targetID) targetID = (0, $b938cbac48dc0193$export$c28d632fe28a2226);
        const $target = $(`#${targetID}`);
        if (!$target.length) return;
        if ($target.hasClass("page-content")) swapPages($target, null, "top", false);
        else if ($target.hasClass("content-info")) {
            //target is popup, so first get page having that popup, move to that page and activate the popup
            let $targetPage = (0, $d465b9e7e2f0fb62$export$293e19f0ac43283a)($target.attr("id"));
            if (!$targetPage.length) $targetPage = $(`#${(0, $b938cbac48dc0193$export$c28d632fe28a2226)}`);
            swapPages($targetPage, null, "top", false);
            $target.addClass("active");
        }
    });
    //mim logo white/dark colors
    (function() {
        const logo = [
            ...document.querySelectorAll('.static-page .page-logo')
        ];
        if (logo.length < 1) return;
        const logoHeight = logo[0].getBoundingClientRect().height; //parseInt(getComputedStyle(logo).getPropertyValue('--header-height'), 10);
        const settings = {
            selector: '.content-info__featured-image, .content-info__inner-content',
            thresholdRatio: 0,
            IntersectionObserverOptions: {
                root: null,
                rootMargin: `-${logoHeight * .5}px 0px -${window.innerHeight - logoHeight * .5}px`,
                threshold: thresholdArray(20)
            }
        };
        const targets = document.querySelectorAll(settings.selector);
        if (!targets) return;
        function callback(entries) {
            entries.forEach((entry)=>{
                const targetRatio = settings.thresholdRatio;
                const ratio = entry.intersectionRatio;
                const isIntersecting = entry.isIntersecting;
                if (isIntersecting && ratio >= targetRatio) {
                    if (!entry.target.dataset.logo) return;
                    const theme = entry.target.dataset.logo ?? 'dark';
                    const page = entry.target.closest('.static-page');
                    [
                        ...page.querySelectorAll('.page-logo')
                    ].forEach((el)=>el.dataset.theme = theme);
                }
            });
        }
        targets.forEach((target)=>{
            const targetOptions = {
                rootMargin: settings.IntersectionObserverOptions.rootMargin
            };
            const options = Object.assign(settings.IntersectionObserverOptions, targetOptions);
            const observer = new IntersectionObserver(callback, options);
            observer.observe(target);
        });
        function thresholdArray(steps) {
            return Array(steps + 1).fill(0).map((_, index)=>index / steps || 0);
        }
    })();
    $body.removeClass("no-transitions"); //there are some class changes during page loading, do not animate them
});

})();
//# sourceMappingURL=custom.js.map
